import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.fab.chat');
import { ElementRef, HostBinding, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { AlsphereChat } from "src/libs/portal/fab/alsphere-chat";
import { chatSession } from "src/libs/portal/fab/chat-session";

@Component({
    selector: 'wiz-portal-fab-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.fab.chat/view.scss */
:host {
  display: block;
}

:host(.is-inline) {
  display: block;
  height: 100%;
  min-height: 0;
}

.nf-floating-chat {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 90;
  pointer-events: none;
}

.nf-floating-chat > * {
  pointer-events: auto;
}

.nf-floating-chat.is-agent-chat-suppressed {
  display: none !important;
}

.nf-floating-chat-launcher {
  position: relative;
  display: flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #b8cae1;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.2);
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}

.nf-floating-chat-launcher:hover {
  border-color: #2e6fae;
  box-shadow: 0 20px 52px rgba(46, 111, 174, 0.28);
  transform: translateY(-2px);
}

.nf-floating-chat-launcher:focus-visible {
  outline: 3px solid rgba(46, 111, 174, 0.24);
  outline-offset: 3px;
}

.nf-floating-chat-launcher-face {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

.nf-floating-chat-launcher-dot {
  position: absolute;
  right: 3px;
  bottom: 3px;
  display: inline-flex;
  width: 21px;
  min-width: 21px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffffff;
  border-radius: 999px;
  background: #153e66;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
}

.nf-floating-chat-panel {
  position: relative;
  display: grid;
  width: min(560px, 100vw - 32px);
  height: min(760px, 100vh - 122px);
  max-height: min(760px, 100vh - 122px);
  grid-template-rows: auto minmax(140px, 1fr) auto;
  overflow: hidden;
  border: 1px solid #c8d6e8;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
}

.nf-floating-chat-resize-handle {
  position: absolute;
  top: 5px;
  left: 5px;
  z-index: 3;
  display: grid;
  width: 25px;
  height: 25px;
  cursor: nwse-resize;
  place-content: center;
  gap: 2px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.88);
  touch-action: none;
}

.nf-floating-chat-resize-handle span {
  display: block;
  height: 1px;
  border-radius: 999px;
  background: #64748b;
  transform: rotate(-45deg);
}

.nf-floating-chat-resize-handle span:nth-child(1) {
  width: 6px;
  margin-left: 8px;
}

.nf-floating-chat-resize-handle span:nth-child(2) {
  width: 10px;
  margin-left: 4px;
}

.nf-floating-chat-resize-handle span:nth-child(3) {
  width: 14px;
}

.nf-floating-chat-resize-handle:hover {
  border-color: #a9c7ff;
  background: #edf6ff;
}

.nf-floating-chat-resize-handle:focus-visible {
  outline: 3px solid rgba(46, 111, 174, 0.28);
  outline-offset: 1px;
}

.nf-floating-chat.is-resizing,
.nf-floating-chat.is-resizing * {
  cursor: nwse-resize !important;
  user-select: none;
}

.nf-floating-chat-header {
  display: flex;
  min-height: 66px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e8edf5;
  padding: 10px 12px 10px 34px;
}

.nf-floating-chat-title {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
}

.nf-floating-chat-title strong,
.nf-floating-chat-title small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-floating-chat-title strong {
  color: #0f172a;
  font-size: 14px;
  font-weight: 700;
}

.nf-floating-chat-title small {
  margin-top: 2px;
  color: #64748b;
  font-size: 12px;
}

.nf-floating-chat-face-wrap {
  display: flex;
  width: 42px;
  height: 42px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f7fbff;
}

.nf-floating-chat-face {
  width: 40px;
  height: 40px;
  object-fit: contain;
}

.nf-floating-chat-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
}

.nf-floating-chat-actions button {
  display: inline-flex;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9e1ec;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
}

.nf-floating-chat-actions button:hover {
  border-color: #a9c7ff;
  background: #edf6ff;
  color: #153e66;
}

.nf-floating-chat-actions svg {
  width: 16px;
  height: 16px;
}

.nf-floating-chat-body {
  min-height: 0;
  overflow-y: auto;
  background: #f7f9fc;
  padding: 14px;
}

.nf-floating-chat-message {
  width: fit-content;
  max-width: 92%;
  margin-bottom: 10px;
  border: 1px solid #d9e1ec;
  border-radius: 14px;
  background: #ffffff;
  padding: 9px 11px;
  color: #0f172a;
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
}

.nf-floating-chat-message.is-review {
  width: 100%;
  max-width: 100%;
}

.nf-floating-chat-message.is-assistant {
  width: 92%;
  box-sizing: border-box;
}

.nf-floating-chat-message.is-generation {
  width: 100%;
  max-width: 100%;
}

.nf-floating-generation-process {
  display: grid;
  gap: 9px;
}

.nf-floating-generation-process > header {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #153e66;
  font-size: 12px;
}

.nf-floating-generation-process ol {
  display: grid;
  gap: 7px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nf-floating-generation-process li {
  display: grid;
  grid-template-columns: 9px minmax(0, 1fr) auto;
  align-items: start;
  gap: 7px;
  border-top: 1px solid #e8edf5;
  padding-top: 7px;
}

.nf-floating-generation-process li > i {
  display: block;
  width: 8px;
  height: 8px;
  margin-top: 4px;
  border-radius: 999px;
  background: #2e6fae;
  box-shadow: 0 0 0 3px rgba(46, 111, 174, 0.12);
}

.nf-floating-generation-process li.is-requested > i {
  background: #d97706;
  box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.14);
}

.nf-floating-generation-process li.is-waiting > i,
.nf-floating-generation-process li.is-pending > i {
  background: #64748b;
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.14);
}

.nf-floating-generation-process li > span {
  display: grid;
  min-width: 0;
  gap: 2px;
}

.nf-floating-generation-process li strong,
.nf-floating-generation-process li small {
  overflow-wrap: anywhere;
}

.nf-floating-generation-process li strong {
  color: #1e293b;
  font-size: 12px;
}

.nf-floating-generation-process li small {
  color: #64748b;
  font-size: 11px;
  line-height: 1.45;
}

.nf-floating-generation-process li em {
  color: #64748b;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  white-space: nowrap;
}

.nf-floating-generation-process li.is-requested em {
  color: #a16207;
}

.nf-floating-chat-message p {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 13px;
  line-height: 1.58;
}

.nf-floating-chat-message.is-user {
  margin-left: auto;
  border-color: #153e66;
  background: #153e66;
  color: #ffffff;
  box-shadow: none;
}

.nf-floating-chat-message.is-error {
  border-color: #fecdd3;
  background: #fff1f2;
  color: #be123c;
}

.nf-floating-intent-review {
  display: grid;
  gap: 9px;
  width: 100%;
}

.nf-floating-intent-review > header,
.nf-floating-chat-table > header,
.nf-floating-chat-chart > header {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.nf-floating-intent-review > header span,
.nf-floating-chat-table > header span,
.nf-floating-chat-chart > header span,
.nf-floating-chat-quality summary span {
  display: inline-flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
  color: #153e66;
  font-size: 12px;
  font-weight: 750;
}

.nf-floating-intent-review > header small,
.nf-floating-chat-table > header small,
.nf-floating-chat-chart > header small,
.nf-floating-chat-quality summary small {
  flex: 0 0 auto;
  color: #64748b;
  font-size: 12px;
}

.nf-floating-intent-review dl {
  display: grid;
  gap: 6px;
  margin: 0;
}

.nf-floating-intent-review dl div {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  padding: 7px 8px;
}

.nf-floating-intent-review dt,
.nf-floating-intent-review dd {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
}

.nf-floating-intent-review dt {
  color: #64748b;
  font-weight: 700;
}

.nf-floating-intent-review dd {
  min-width: 0;
  color: #1e293b;
  font-weight: 650;
  word-break: break-word;
}

.nf-floating-intent-reasons {
  display: grid;
  gap: 5px;
  border: 1px solid #f5c46b;
  border-radius: 8px;
  background: #fffbeb;
  padding: 7px 9px;
}

.nf-floating-intent-reasons strong {
  color: #92400e;
  font-size: 12px;
}

.nf-floating-intent-reasons ul {
  display: grid;
  gap: 3px;
  margin: 0;
  padding-left: 17px;
}

.nf-floating-intent-reasons li {
  color: #78350f;
  font-size: 12px;
  line-height: 1.4;
}

.nf-floating-intent-skills,
.nf-floating-intent-actions,
.nf-floating-intent-mode-group,
.nf-floating-chat-modebar,
.nf-floating-chat-mode-group {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.nf-floating-intent-skills span {
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  padding: 3px 7px;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 700;
}

.nf-floating-intent-error {
  border: 1px solid #fecdd3;
  border-radius: 8px;
  background: #fff1f2;
  padding: 7px 8px;
  color: #be123c;
}

.nf-floating-intent-actions {
  justify-content: flex-end;
}

.nf-floating-intent-actions button,
.nf-floating-intent-mode-group button,
.nf-floating-chat-mode-group button {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #ffffff;
  padding: 0 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.nf-floating-intent-actions button.is-primary,
.nf-floating-chat-mode-group button.is-active {
  border-color: #153e66;
  background: #153e66;
  color: #ffffff;
}

.nf-floating-intent-mode-group button.is-active {
  border-color: #2e6fae;
  background: #edf6ff;
  color: #153e66;
}

.nf-floating-intent-actions button:disabled,
.nf-floating-intent-mode-group button:disabled,
.nf-floating-chat-mode-group button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.nf-floating-intent-mode-group button span,
.nf-floating-chat-mode-group button span {
  display: inline-flex;
  min-width: 20px;
  justify-content: center;
  font-size: 12px;
}

.nf-floating-intent-editor {
  display: grid;
  gap: 8px;
}

.nf-floating-intent-editor textarea {
  width: 100%;
  min-height: 74px;
  resize: vertical;
  border: 1px solid #c8d6e8;
  border-radius: 8px;
  background: #ffffff;
  padding: 8px 9px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.45;
}

.nf-floating-intent-editor textarea:focus {
  border-color: #2e6fae;
  box-shadow: 0 0 0 3px rgba(46, 111, 174, 0.12);
  outline: none;
}

.nf-floating-intent-working {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #475569;
  font-size: 12px;
}

.nf-floating-intent-working span {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #2e6fae;
  animation: nf-floating-chat-bounce 0.9s infinite ease-in-out;
}

.nf-floating-intent-working span:nth-child(2) {
  animation-delay: 0.12s;
}

.nf-floating-intent-working span:nth-child(3) {
  animation-delay: 0.24s;
}

.nf-floating-chat-report {
  display: grid;
  gap: 8px;
  margin-top: 10px;
  overflow: hidden;
  border: 1px solid #bfd4ec;
  border-radius: 11px;
  background: #f8fbff;
}

.nf-floating-chat-report > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-bottom: 1px solid #dce8f5;
  padding: 8px 9px;
}

.nf-floating-chat-report > header span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #153e66;
  font-size: 12px;
  font-weight: 750;
}

.nf-floating-chat-report > header small {
  color: #64748b;
  font-size: 12px;
}

.nf-floating-chat-report pre {
  max-height: 210px;
  margin: 0;
  overflow: auto;
  padding: 2px 10px 6px;
  color: #334155;
  font-family: "Pretendard Variable", Pretendard, sans-serif;
  font-size: 12px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}

.nf-floating-chat-report-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  border-top: 1px solid #dce8f5;
  padding: 8px 9px;
}

.nf-floating-chat-report-actions button {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 5px;
  border: 1px solid #bfd4ec;
  border-radius: 999px;
  background: #ffffff;
  padding: 0 9px;
  color: #24547e;
  font-size: 12px;
  font-weight: 700;
}

.nf-floating-chat-report-actions button:hover {
  border-color: #6fa3d4;
  background: #eaf4ff;
}

.nf-floating-chat-table,
.nf-floating-chat-chart,
.nf-floating-chat-quality {
  display: grid;
  min-width: 0;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  margin-top: 10px;
  border: 1px solid #d9e1ec;
  border-radius: 8px;
  background: #fbfdff;
  padding: 8px;
}

.nf-floating-chat-chart header {
  overflow-wrap: anywhere;
}

.nf-floating-chat-table-wrap {
  overflow-x: auto;
}

.nf-floating-chat-table table {
  width: 100%;
  min-width: 360px;
  border-collapse: collapse;
}

.nf-floating-chat-table th,
.nf-floating-chat-table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 6px 7px;
  text-align: left;
  vertical-align: top;
  font-size: 12px;
  line-height: 1.35;
}

.nf-floating-chat-table th {
  color: #475569;
  font-weight: 750;
}

.nf-floating-chat-table td {
  color: #0f172a;
}

.nf-floating-chat-table tbody tr:last-child td {
  border-bottom: 0;
}

.nf-floating-chart-bars {
  display: grid;
  min-height: 170px;
  grid-auto-flow: column;
  grid-auto-columns: minmax(42px, 1fr);
  align-items: end;
  gap: 7px;
  overflow-x: auto;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 8px 8px;
}

.nf-floating-chart-bar {
  display: grid;
  grid-template-rows: auto 100px auto;
  min-width: 42px;
  height: 145px;
  align-items: end;
  justify-items: center;
  gap: 5px;
}

.nf-floating-chart-bar i {
  position: absolute;
  display: block;
  width: 100%;
  border-radius: 7px 7px 3px 3px;
  background: linear-gradient(180deg, #2e6fae, #1f9f8f);
}

.nf-floating-chart-plot {
  position: relative;
  width: 100%;
  height: 100px;
}

.nf-floating-chart-zero {
  position: absolute;
  z-index: 1;
  width: 100%;
  border-top: 1px solid #94a3b8;
}

.nf-floating-chart-bar i.is-negative {
  background: #b45309;
}

.nf-floating-chart-caption {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.nf-floating-chart-value,
.nf-floating-chart-bar b {
  max-width: 72px;
  overflow: hidden;
  color: #475569;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nf-floating-chart-value {
  color: #153e66;
  font-weight: 750;
}

.nf-floating-chat-quality summary {
  display: flex;
  min-width: 0;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  list-style: none;
}

.nf-floating-chat-quality summary::-webkit-details-marker {
  display: none;
}

.nf-floating-chat-quality p {
  color: #475569;
  font-size: 12px;
  line-height: 1.45;
}

.nf-floating-chat-runtime {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 8px;
}

.nf-floating-chat-runtime span {
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #f8fafc;
  padding: 3px 7px;
  color: #475569;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.35;
}

.nf-floating-chat-runtime span.is-sample,
.nf-floating-chat-runtime span.is-warning {
  border-color: #f5c46b;
  background: #fffbeb;
  color: #92400e;
}

.nf-floating-chat-runtime span.is-success {
  border-color: #86efac;
  background: #f0fdf4;
  color: #166534;
}

.nf-floating-chat-citations {
  display: grid;
  gap: 4px;
  margin-top: 8px;
  border-top: 1px solid #e8edf5;
  padding-top: 8px;
}

.nf-floating-source-card {
  min-width: 0;
  border: 1px solid #dbe5f2;
  border-radius: 8px;
  overflow-wrap: anywhere;
}

.nf-floating-source-card summary {
  padding: 9px 11px;
  color: #245b92;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.nf-floating-source-card summary:hover {
  background: rgba(37, 99, 235, 0.05);
}

.nf-floating-source-card summary:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.nf-floating-source-detail {
  display: grid;
  gap: 8px;
  padding: 0 11px 11px;
}

.nf-floating-answer-attribution {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 14px;
  margin-top: 12px;
  padding-top: 9px;
  border-top: 1px solid #e2e8f0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

:host ::ng-deep .nf-floating-answer-content {
  color: inherit;
  font-size: 14px;
  line-height: 1.8;
  overflow-wrap: anywhere;
}
:host ::ng-deep .nf-floating-answer-content > :first-child {
  margin-top: 0;
}
:host ::ng-deep .nf-floating-answer-content > :last-child {
  margin-bottom: 0;
}
:host ::ng-deep .nf-floating-answer-content p {
  margin: 0 0 12px;
  white-space: normal;
  font-size: inherit;
  line-height: inherit;
}
:host ::ng-deep .nf-floating-answer-content h1, :host ::ng-deep .nf-floating-answer-content h2, :host ::ng-deep .nf-floating-answer-content h3, :host ::ng-deep .nf-floating-answer-content h4, :host ::ng-deep .nf-floating-answer-content h5, :host ::ng-deep .nf-floating-answer-content h6 {
  margin: 18px 0 8px;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.5;
}
:host ::ng-deep .nf-floating-answer-content strong {
  font-weight: 750;
}
:host ::ng-deep .nf-floating-answer-content ul, :host ::ng-deep .nf-floating-answer-content ol {
  margin: 8px 0 14px;
  padding-left: 22px;
}
:host ::ng-deep .nf-floating-answer-content ul {
  list-style: disc;
}
:host ::ng-deep .nf-floating-answer-content ol {
  list-style: decimal;
}
:host ::ng-deep .nf-floating-answer-content li {
  margin: 5px 0;
  padding-left: 2px;
}
:host ::ng-deep .nf-floating-answer-content blockquote {
  margin: 12px 0;
  padding: 8px 12px;
  border-left: 3px solid #93b4dc;
  background: rgba(59, 130, 246, 0.05);
}
:host ::ng-deep .nf-floating-answer-content code {
  padding: 1px 4px;
  border-radius: 4px;
  background: rgba(148, 163, 184, 0.14);
  font-size: 12px;
}
:host ::ng-deep .nf-floating-answer-content pre {
  margin: 12px 0;
  padding: 10px;
  overflow: auto;
  background: rgba(148, 163, 184, 0.1);
  border-radius: 7px;
}
:host ::ng-deep .nf-floating-answer-content pre code {
  padding: 0;
  background: none;
  white-space: pre;
}
:host ::ng-deep .nf-floating-answer-content table {
  display: block;
  max-width: 100%;
  overflow: auto;
  border-collapse: collapse;
  font-size: 12px;
}
:host ::ng-deep .nf-floating-answer-content th, :host ::ng-deep .nf-floating-answer-content td {
  padding: 7px 9px;
  border: 1px solid #dbe5f2;
  text-align: left;
}
:host ::ng-deep .nf-floating-answer-content th {
  background: rgba(148, 163, 184, 0.08);
  font-weight: 700;
}

:host-context([data-theme=dark]) .nf-floating-source-card summary {
  color: #93c5fd;
}

:host-context([data-theme=dark]) .nf-floating-answer-attribution,
:host-context([data-theme=dark]) .nf-floating-source-card small {
  color: #a5b4c8;
}

.nf-floating-source-card small {
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.nf-floating-source-card p {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
}

.nf-floating-source-card dl {
  display: grid;
  gap: 4px;
  margin: 0;
  font-size: 12px;
}

.nf-floating-source-card dl div {
  display: grid;
  grid-template-columns: minmax(80px, 1fr) minmax(0, 2fr);
  gap: 8px;
}

.nf-floating-source-card dd {
  margin: 0;
}

.nf-floating-chat-links,
.nf-floating-chat-followups {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.nf-floating-chat-links a,
.nf-floating-chat-followups button {
  max-width: 100%;
  border: 1px solid #d9e1ec;
  border-radius: 999px;
  background: #ffffff;
  padding: 5px 9px;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  text-decoration: none;
}

.nf-floating-chat-links a:hover,
.nf-floating-chat-followups button:hover {
  border-color: #a9c7ff;
  background: #edf6ff;
  color: #153e66;
}

.nf-floating-chat-message.is-loading {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 12px;
}

.nf-floating-chat-message.is-loading span {
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #2e6fae;
  animation: nf-floating-chat-bounce 0.9s infinite ease-in-out;
}

.nf-floating-chat-message.is-loading span:nth-child(2) {
  animation-delay: 0.12s;
}

.nf-floating-chat-message.is-loading span:nth-child(3) {
  animation-delay: 0.24s;
}

.nf-floating-chat-composer {
  display: grid;
  gap: 8px;
  padding: 10px 12px 12px;
}

.nf-floating-chat-modebar {
  align-items: center;
  justify-content: space-between;
}

.nf-floating-chat-mode-group {
  min-width: min(100%, 290px);
}

.nf-floating-chat-modebar select {
  min-width: 112px;
  max-width: 150px;
  height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 8px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.nf-floating-chat-modebar select:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.nf-floating-chat-composer textarea {
  width: 100%;
  min-height: 58px;
  resize: none;
  border: 1px solid #c8d6e8;
  border-radius: 12px;
  background: #ffffff;
  padding: 9px 10px;
  color: #0f172a;
  font-size: 13px;
  line-height: 1.5;
}

.nf-floating-chat-composer textarea:focus {
  border-color: #2e6fae;
  box-shadow: 0 0 0 3px rgba(46, 111, 174, 0.12);
  outline: none;
}

.nf-floating-chat-composer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.nf-floating-chat-key-hint {
  flex: 1 0 100%;
  margin-right: auto;
  color: #64748b;
  font-size: 12px;
  line-height: 1.3;
}

.nf-floating-chat-secondary,
.nf-floating-chat-submit {
  height: 34px;
  border-radius: 999px;
  padding: 0 13px;
  font-size: 12px;
  font-weight: 700;
}

.nf-floating-chat-secondary {
  border: 1px solid #d9e1ec;
  background: #ffffff;
  color: #475569;
}

.nf-floating-chat-submit {
  border: 1px solid #153e66;
  background: #153e66;
  color: #ffffff;
}

.nf-floating-chat-submit:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.nf-floating-chat-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

@keyframes nf-floating-chat-bounce {
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
}
:host-context([data-theme=dark]) .nf-floating-chat-panel {
  border-color: rgba(148, 163, 184, 0.34);
  background: #0f172a;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.44);
}

:host-context([data-theme=dark]) .nf-floating-chat-resize-handle {
  background: rgba(15, 23, 42, 0.9);
}

:host-context([data-theme=dark]) .nf-floating-chat-resize-handle span {
  background: #94a3b8;
}

:host-context([data-theme=dark]) .nf-floating-chat-header {
  border-color: rgba(148, 163, 184, 0.22);
}

:host-context([data-theme=dark]) .nf-floating-chat-body {
  background: #071321;
}

:host-context([data-theme=dark]) .nf-floating-chat-title strong,
:host-context([data-theme=dark]) .nf-floating-chat-message,
:host-context([data-theme=dark]) .nf-floating-chat-composer textarea {
  color: #e5eef8;
}

:host-context([data-theme=dark]) .nf-floating-chat-message,
:host-context([data-theme=dark]) .nf-floating-chat-actions button,
:host-context([data-theme=dark]) .nf-floating-chat-composer textarea,
:host-context([data-theme=dark]) .nf-floating-chat-modebar select,
:host-context([data-theme=dark]) .nf-floating-chat-secondary,
:host-context([data-theme=dark]) .nf-floating-chat-report,
:host-context([data-theme=dark]) .nf-floating-intent-review dl div,
:host-context([data-theme=dark]) .nf-floating-intent-editor textarea,
:host-context([data-theme=dark]) .nf-floating-intent-actions button,
:host-context([data-theme=dark]) .nf-floating-intent-mode-group button,
:host-context([data-theme=dark]) .nf-floating-chat-mode-group button,
:host-context([data-theme=dark]) .nf-floating-chat-table,
:host-context([data-theme=dark]) .nf-floating-chat-chart,
:host-context([data-theme=dark]) .nf-floating-chart-bars,
:host-context([data-theme=dark]) .nf-floating-chat-quality,
:host-context([data-theme=dark]) .nf-floating-chat-report-actions button,
:host-context([data-theme=dark]) .nf-floating-chat-links a,
:host-context([data-theme=dark]) .nf-floating-chat-followups button {
  border-color: rgba(148, 163, 184, 0.28);
  background: #111c2e;
}

:host-context([data-theme=dark]) .nf-floating-intent-reasons {
  border-color: rgba(245, 196, 107, 0.42);
  background: rgba(146, 64, 14, 0.16);
}

:host-context([data-theme=dark]) .nf-floating-intent-reasons strong,
:host-context([data-theme=dark]) .nf-floating-intent-reasons li {
  color: #fcd34d;
}

:host-context([data-theme=dark]) .nf-floating-chat-report,
:host-context([data-theme=dark]) .nf-floating-chat-report > header,
:host-context([data-theme=dark]) .nf-floating-chat-report-actions,
:host-context([data-theme=dark]) .nf-floating-chat-report-actions button,
:host-context([data-theme=dark]) .nf-floating-chat-table,
:host-context([data-theme=dark]) .nf-floating-chat-chart,
:host-context([data-theme=dark]) .nf-floating-chat-quality {
  border-color: rgba(148, 163, 184, 0.28);
}

:host-context([data-theme=dark]) .nf-floating-chat-report > header span,
:host-context([data-theme=dark]) .nf-floating-chat-report pre,
:host-context([data-theme=dark]) .nf-floating-chat-report-actions button,
:host-context([data-theme=dark]) .nf-floating-intent-review > header span,
:host-context([data-theme=dark]) .nf-floating-chat-table > header span,
:host-context([data-theme=dark]) .nf-floating-chat-chart > header span,
:host-context([data-theme=dark]) .nf-floating-chat-quality summary span,
:host-context([data-theme=dark]) .nf-floating-intent-review dd,
:host-context([data-theme=dark]) .nf-floating-chat-table td,
:host-context([data-theme=dark]) .nf-floating-chart-value,
:host-context([data-theme=dark]) .nf-floating-generation-process li strong {
  color: #dbeafe;
}

:host-context([data-theme=dark]) .nf-floating-intent-review dt,
:host-context([data-theme=dark]) .nf-floating-chat-table th,
:host-context([data-theme=dark]) .nf-floating-chart-bar b,
:host-context([data-theme=dark]) .nf-floating-chat-quality p,
:host-context([data-theme=dark]) .nf-floating-generation-process li small,
:host-context([data-theme=dark]) .nf-floating-generation-process li em,
:host-context([data-theme=dark]) .nf-floating-chat-modebar select {
  color: #cbd5e1;
}

@media (max-width: 640px) {
  .nf-floating-chat {
    right: 12px;
    bottom: 14px;
    left: 12px;
  }
  .nf-floating-chat-launcher {
    margin-left: auto;
  }
  .nf-floating-chat-panel {
    width: 100%;
    height: calc(100vh - 86px);
    max-height: calc(100vh - 86px);
    border-radius: 14px;
  }
  .nf-floating-chat-resize-handle {
    display: none;
  }
  .nf-floating-chat-header {
    padding-left: 14px;
  }
  .nf-floating-chat-modebar,
  .nf-floating-chat-mode-group,
  .nf-floating-chat-modebar select {
    width: 100%;
  }
}
.nf-floating-source-image-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 0;
}
.nf-floating-source-image-toolbar strong {
  flex: 1;
  font-size: 13px;
}
.nf-floating-source-image-toolbar button {
  width: 30px;
  height: 30px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  color: #1d4ed8;
  background: #fff;
  cursor: pointer;
}
.nf-floating-source-image-toolbar button:disabled {
  opacity: 0.4;
  cursor: default;
}
.nf-floating-source-image-toolbar span {
  font-size: 12px;
}

.nf-floating-source-image-viewport {
  max-height: 65vh;
  overflow: auto;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #e2e8f0;
}
.nf-floating-source-image-viewport img {
  display: block;
  max-width: none;
  height: auto;
  margin: 0;
  background: #fff;
}

.nf-floating-retrieval {
  display: grid;
  gap: 8px;
  margin: 14px 0 0;
  padding: 12px;
  border: 1px solid #dbe4f0;
  border-radius: 8px;
  background: #f8fafc;
}
.nf-floating-retrieval > div {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr);
  gap: 10px;
}
.nf-floating-retrieval dt {
  font-weight: 600;
  color: #475569;
  font-size: 12px;
}
.nf-floating-retrieval dd {
  margin: 0;
  color: #334155;
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.nf-execution-events, .nf-sources-collection {
  margin-top: 12px;
  border: 1px solid #dce4ef;
  border-radius: 12px;
  padding: 12px;
  background: #f8fafc;
  color: #334155;
}
.nf-execution-events > summary, .nf-sources-collection > summary {
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.nf-execution-events > summary:focus-visible, .nf-sources-collection > summary:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 3px;
}

.nf-sources-summary small {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.nf-source-support {
  margin: 7px 0;
  font-size: 12px;
  line-height: 1.6;
  color: #475569;
}

.nf-current-progress {
  display: grid;
  grid-template-columns: 54px minmax(0, 1fr);
  align-items: center;
  gap: 4px 14px;
  min-width: 0;
  padding: 6px 0;
  color: #334155;
  font-size: 14px;
  line-height: 24px;
}
.nf-current-progress > .nf-current-tool {
  grid-column: 1/-1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
}
.nf-current-progress > small {
  color: #2563eb;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.nf-current-progress > span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}
.nf-current-progress[data-status=completed] > small {
  color: #15803d;
}
.nf-current-progress[data-status=failed] > small {
  color: #b91c1c;
}
.nf-current-progress[data-status=retrying] > small, .nf-current-progress[data-status=no_data] > small, .nf-current-progress[data-status=skipped] > small, .nf-current-progress[data-status=fallback] > small {
  color: #92400e;
}

.nf-execution-events ol {
  padding: 0;
  list-style: none;
  max-height: 220px;
  overflow-y: auto;
}

.nf-execution-events li {
  display: flex;
  gap: 8px;
  padding: 5px 0;
  font-size: 12px;
  line-height: 1.6;
}

.nf-execution-events li small {
  flex: 0 0 48px;
  color: #2563eb;
}

.nf-execution-events li[data-status=failed] small {
  color: #b91c1c;
}

.nf-execution-events li[data-status=retrying] small,
.nf-execution-events li[data-status=no_data] small {
  color: #92400e;
}

.nf-answer-warning {
  margin-top: 8px;
  color: #92400e;
  font-size: 12px;
  line-height: 1.6;
}

.nf-answer-attribution {
  display: flex;
  flex-wrap: wrap;
  gap: 5px 12px;
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid #e2e8f0;
  font-size: 12px;
  color: #64748b;
}

.nf-streaming-answer {
  margin: 8px 0;
  color: #2563eb;
  font-size: 12px;
  line-height: 1.6;
}

.nf-floating-generation-process li.is-running > i,
.nf-floating-generation-process li.is-retrying > i {
  background: #2563eb;
  box-shadow: 0 0 0 3px #dbeafe;
}

.nf-floating-generation-process li.is-running em,
.nf-floating-generation-process li.is-retrying em {
  color: #2563eb;
  font-weight: 700;
}

.nf-floating-generation-process li.is-completed > i {
  background: #16a34a;
}

.nf-floating-generation-process li.is-failed > i {
  background: #dc2626;
}

.alsphere-chat-attachments {
  margin-top: 8px;
  font-size: 11px;
  color: #536579;
}
.alsphere-chat-attachments .alsphere-chat-attachment-actions, .alsphere-chat-attachments .alsphere-chat-file, .alsphere-chat-attachments .alsphere-chat-followup {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 5px;
  min-width: 0;
}
.alsphere-chat-attachments .alsphere-chat-file > span {
  overflow-wrap: anywhere;
}
.alsphere-chat-attachments button {
  border: 1px solid #bdd0e5;
  border-radius: 8px;
  background: #f1f7ff;
  color: #15539a;
  padding: 4px 8px;
  font-size: 11px;
  white-space: nowrap;
  cursor: pointer;
}
.alsphere-chat-attachments button:disabled {
  opacity: 0.45;
  cursor: default;
}
.alsphere-chat-attachments p[role=alert] {
  margin: 5px 0 0;
  color: #b42318;
  overflow-wrap: anywhere;
}

.nf-floating-chat.is-inline {
  position: relative;
  inset: auto;
  z-index: auto;
  height: 100%;
  min-height: 0;
  width: 100%;
  pointer-events: auto;
}
.nf-floating-chat.is-inline .nf-floating-chat-panel {
  width: 100%;
  height: 100%;
  max-height: none;
  border: 0;
  border-radius: 0;
  box-shadow: none;
}
.nf-floating-chat.is-inline .nf-floating-chat-header {
  padding-left: 18px;
}
.nf-floating-chat.is-inline .nf-floating-chat-body {
  padding: 18px;
}
.nf-floating-chat.is-inline .nf-floating-chat-composer {
  padding: 12px 18px 18px;
}

@media print {
  :host-context(html.report-print-active) .nf-floating-chat {
    display: none !important;
  }
}`],
})
export class PortalFabChatComponent implements OnInit, OnDestroy {
    @Input() inline: boolean = false;
    @Input() locked: boolean = false;
    @HostBinding('class.is-inline') get inlineHost() { return this.inline; }
    public chatSession = chatSession;
    private sharedSnapshot: any = null;
    private unsubscribeSession: (() => void) | null = null;
    private ready: boolean = false;
    private resolveReady: () => void;
    private readonly readyPromise = new Promise<void>(resolve => { this.resolveReady = resolve; });
    public alsphereChat = new AlsphereChat({
        messages: () => this.floatingChatMessages,
        input: value => { this.floatingChatInput = value; },
        busy: value => { this.floatingChatAsking = value; },
        render: async () => { if (!this.floatingDestroyed) { await this.service.render(); this.scrollFloatingChatToLatestMessage(); } },
        completed: async (question, _result) => { this.floatingLastQuestion = question; await this.persistSharedConversation(); }
    });

    private readonly floatingExampleQuestions: { text: string; agentMode: string }[] = [
        { text: '알세미 증착 모델로 온도 350, 압력 3.5 조건을 예측하고 싶어요', agentMode: 'auto' },
        { text: '반도체 식각 공정에서 선택비와 균일도에 영향을 주는 주요 요인은 무엇인가요?', agentMode: 'simple' },
        { text: '식각 공정에 사용하는 장비 목록을 보여줘.', agentMode: 'data_search' },
        { text: 'CMP 공정에서 결함이 증가할 때 우선 확인할 변수는 무엇인가요?', agentMode: 'simple' },
        { text: 'CMP 공정 데이터로 가상계측 모델을 실행해 두께를 예측해줘.', agentMode: 'ai_model' }
    ];
    public floatingChatOpen: boolean = false;
    public floatingChatInput: string = '';
    public floatingChatAsking: boolean = false;
    public floatingChatMessages: any[] = [
        {
            role: 'assistant',
            content: 'NanoFab Studio에서 반도체 공정 원리와 연구 데이터를 함께 살펴볼 수 있습니다. 궁금한 연구 주제를 질문해 주세요.',
            followups: this.floatingExampleQuestions.map(item => item.text)
        }
    ];
    public readonly floatingAgentModes: any[] = [
        { id: 'auto', label: '자동', title: '자동 선택', marker: 'AI' },
        { id: 'data_search', label: '데이터 검색', title: '데이터 검색', marker: 'D' },
        { id: 'simple', label: '단순 질의', title: '단순 질의', marker: 'Q' },
        { id: 'ai_model', label: 'AI 모델 사용', title: 'AI 모델 사용', marker: 'M' }
    ];
    public readonly floatingToolExecutionModes: any[] = [
        { id: 'auto', label: '자동 실행' },
        { id: 'sequential', label: '순차 실행' },
        { id: 'parallel', label: '병렬 실행' }
    ];
    public floatingAgentMode: string = 'auto';
    public floatingToolExecutionMode: string = 'auto';
    public floatingLastQuestion: string = '';
    public floatingChatWidth: number = 560;
    public floatingChatHeight: number = 760;
    public floatingChatResizing: boolean = false;
    private readonly floatingChatSizeStorageKey: string = 'nanofab.floating-chat.size.v1';
    private readonly floatingChatDefaultWidth: number = 560;
    private readonly floatingChatDefaultHeight: number = 760;
    private readonly floatingChatMinimumWidth: number = 360;
    private readonly floatingChatMinimumHeight: number = 440;
    private floatingPendingAgentRequest: any = null;
    private floatingAskSeq: number = 0;
    private floatingActiveController: AbortController | null = null;
    private floatingConversationBinding: any = null;
    private floatingConversationState: any = null;
    private floatingExecutionRequest: any = null;
    private floatingResultReferences: any[] = [];
    private floatingResizePointerId: number | null = null;
    private floatingResizeStart: any = null;
    private floatingResizeHandle: HTMLElement | null = null;
    private floatingResizeMoveListener: ((event: PointerEvent) => void) | null = null;
    private floatingResizeEndListener: ((event: PointerEvent) => void) | null = null;
    private floatingTimers: Set<any> = new Set();
    private floatingDestroyed: boolean = false;
    private floatingSourceRequests: Set<AbortController> = new Set();

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private element: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.floatingDestroyed) return;
        this.floatingChatOpen = this.inline;
        this.restoreFloatingChatSize();
        await chatSession.initialize(
            String(this.service.auth.session?.id || this.service.auth.session?.guest_id || ''),
            this.service.auth.status === true ? '' : this.service.auth.session?.guest_csrf
        );
        if (this.floatingDestroyed) return;
        this.restoreSharedConversation(chatSession.current);
        this.unsubscribeSession = chatSession.subscribe((snapshot, origin) => {
            if (this.floatingDestroyed) return;
            if (origin !== this && JSON.stringify(snapshot) !== JSON.stringify(this.sharedSnapshot)) this.restoreSharedConversation(snapshot);
            void this.service.render();
        });
        this.ready = true;
        this.resolveReady();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.resolveReady();
        if (this.unsubscribeSession) this.unsubscribeSession();
        this.interruptFloatingRequest();
        if (this.ready && !this.locked && this.sharedSnapshot?.id === chatSession.current?.id) void this.persistSharedConversation();
        this.alsphereChat.destroy();
        this.floatingDestroyed = true;
        this.cancelFloatingSourceRequests();
        this.removeFloatingChatResizeListeners();
        this.clearFloatingTimers();
    }

    @HostListener('window:pagehide')
    public checkpointBeforeUnload() {
        this.interruptFloatingRequest();
        if (!this.locked) void this.persistSharedConversation();
    }

    @HostListener('window:resize')
    public async handleResize() {
        this.clampFloatingChatSize();
        if (!this.floatingChatResizeEnabled() && this.floatingChatResizing) this.finishFloatingChatResize();
        await this.service.render();
    }

    @HostListener('window:fab-chat-query', ['$event'])
    public async handleSharedQuery(event: any) {
        if (this.locked) return;
        if (!this.inline || !this.ready || this.floatingChatAsking) return;
        const query = String(event?.detail?.query || '').trim();
        if (!query) return;
        this.floatingChatInput = query;
        await this.floatingChatAsk();
    }

    public async submitQuestion(question: string, agentMode: string = 'auto', toolMode: string = 'auto') {
        if (this.locked) return;
        await this.readyPromise;
        if (this.locked || this.floatingDestroyed || this.floatingChatAsking) return;
        this.floatingChatInput = String(question || '');
        this.floatingAgentMode = this.floatingAgentModes.some(mode => mode.id === agentMode) ? agentMode : 'auto';
        this.floatingToolExecutionMode = this.floatingToolExecutionModes.some(mode => mode.id === toolMode) ? toolMode : 'auto';
        await this.floatingChatAsk();
    }

    private restoreSharedConversation(snapshot: any) {
        this.interruptFloatingRequest();
        this.cancelFloatingSourceRequests();
        this.sharedSnapshot = snapshot;
        this.floatingChatMessages = Array.isArray(snapshot?.messages) && snapshot.messages.length
            ? JSON.parse(JSON.stringify(snapshot.messages))
            : [{ role: 'assistant', content: 'NanoFab Studio에서 반도체 공정 원리와 연구 데이터를 함께 살펴볼 수 있습니다. 궁금한 연구 주제를 질문해 주세요.', followups: this.floatingExampleQuestions.map(item => item.text) }];
        this.floatingChatInput = String(snapshot?.draft || '');
        this.floatingConversationBinding = this.normalizeFloatingConversationBinding(snapshot?.conversationBinding);
        this.floatingConversationState = snapshot?.conversationState || null;
        this.floatingExecutionRequest = snapshot?.executionRequest || null;
        this.floatingResultReferences = snapshot?.resultReferences || [];
        const restoredMode = ['virtual_metrology', 'anomaly'].includes(snapshot?.agentMode) ? 'ai_model' : snapshot?.agentMode;
        this.floatingAgentMode = this.floatingAgentModes.some(mode => mode.id === restoredMode) ? restoredMode : 'auto';
        this.floatingToolExecutionMode = this.floatingToolExecutionModes.some(mode => mode.id === snapshot?.toolExecutionMode) ? snapshot.toolExecutionMode : 'auto';
        this.floatingLastQuestion = String([...this.floatingChatMessages].reverse().find(item => item?.role === 'user')?.content || '');
        const pending = snapshot?.pendingRequest;
        this.floatingPendingAgentRequest = pending && Number.isInteger(pending.progressMessageIndex)
            ? { ...pending, progressMessage: this.floatingChatMessages[pending.progressMessageIndex] }
            : null;
        // Transport requests cannot survive a component or document reload.
        for (const message of this.floatingChatMessages) {
            if (!message?.processing && !message?.streaming) continue;
            message.processing = false;
            message.streaming = false;
            message.cancelled = true;
            message.generationProcess = null;
            message.answerFlow = this.cancelFloatingAnswerFlow(message.answerFlow);
            if (message.intentReview?.status === 'analyzing') message.intentReview.status = 'cancelled';
            message.content = message.content || '응답 확인이 중단되었습니다. 질문을 다시 시도해 주세요.';
        }
        for (const message of this.floatingChatMessages) {
            if (this.showFloatingIntentReview(message) && message !== this.floatingPendingAgentRequest?.progressMessage) {
                message.intentReview.status = 'cancelled';
            }
        }
        if (!this.showFloatingIntentReview(this.floatingPendingAgentRequest?.progressMessage)) this.floatingPendingAgentRequest = null;
        this.alsphereChat.restore(snapshot?.alsphereConversation, this.floatingChatMessages, this.floatingChatOpen);
        this.scrollFloatingChatToLatestMessage();
    }

    private interruptFloatingRequest() {
        this.floatingAskSeq++;
        if (this.floatingActiveController) this.floatingActiveController.abort();
        this.floatingActiveController = null;
        this.alsphereChat.abort();
        this.floatingChatAsking = false;
        for (const message of this.floatingChatMessages) {
            if (!message?.processing && !message?.streaming) continue;
            message.processing = false;
            message.streaming = false;
            message.cancelled = true;
            message.generationProcess = null;
            message.answerFlow = this.cancelFloatingAnswerFlow(message.answerFlow);
            if (message.intentReview?.status === 'analyzing') message.intentReview.status = 'cancelled';
            message.content = message.content || '요청을 중단했습니다. 질문을 수정하거나 재시도할 수 있습니다.';
        }
    }

    private async persistSharedConversation() {
        if (!this.ready) return;
        if (!this.sharedSnapshot?.id) {
            chatSession.newConversation(this);
            this.sharedSnapshot = chatSession.current;
        }
        const pending = this.floatingPendingAgentRequest;
        const snapshot: any = {
            ...(this.sharedSnapshot || {}),
            conversationId: this.floatingConversationBinding?.conversationId || this.sharedSnapshot.conversationId || this.alsphereChat.conversationId || this.sharedSnapshot.id,
            messages: this.floatingChatMessages,
            draft: this.floatingChatInput,
            conversationBinding: this.floatingConversationBinding,
            conversationState: this.floatingConversationState,
            executionRequest: this.floatingExecutionRequest,
            resultReferences: this.floatingResultReferences,
            alsphereConversation: this.alsphereChat.snapshot(),
            agentMode: this.floatingAgentMode,
            toolExecutionMode: this.floatingToolExecutionMode,
            pendingRequest: pending ? { ...pending, progressMessage: undefined, progressMessageIndex: this.floatingChatMessages.indexOf(pending.progressMessage) } : null
        };
        const question = this.floatingChatMessages.find(item => item?.role === 'user');
        snapshot.title = Array.from(String(snapshot.title && snapshot.title !== '새 대화' ? snapshot.title : (question?.content || '새 대화'))).slice(0, 160).join('');
        snapshot.preview = String([...this.floatingChatMessages].reverse().find(item => item?.content)?.content || '').slice(0, 160);
        if (!question) {
            chatSession.activate(snapshot, this);
            this.sharedSnapshot = chatSession.current;
            return;
        }
        const saved = chatSession.publish(snapshot, this);
        this.sharedSnapshot = chatSession.current;
        await saved;
    }

    public floatingChatClass() {
        return {
            'is-open': this.floatingChatOpen,
            'is-inline': this.inline,
            'is-resizing': this.floatingChatResizing
        };
    }

    public floatingChatPanelStyle() {
        if (!this.floatingChatResizeEnabled()) return {};
        return {
            width: `${this.floatingChatWidth}px`,
            height: `${this.floatingChatHeight}px`,
            maxHeight: 'none'
        };
    }

    public floatingChatResizeValue() {
        return `현재 너비 ${Math.round(this.floatingChatWidth)}픽셀, 높이 ${Math.round(this.floatingChatHeight)}픽셀`;
    }

    public floatingChatResizeEnabled() {
        return !this.inline && (typeof window === 'undefined' || window.innerWidth > 640);
    }

    public startFloatingChatResize(event: PointerEvent) {
        if (!this.floatingChatResizeEnabled() || event.button !== 0 || this.floatingChatResizing) return;
        event.preventDefault();
        event.stopPropagation();
        const handle = event.currentTarget as HTMLElement | null;
        this.floatingResizePointerId = event.pointerId;
        this.floatingResizeStart = {
            clientX: event.clientX,
            clientY: event.clientY,
            width: this.floatingChatWidth,
            height: this.floatingChatHeight
        };
        this.floatingResizeHandle = handle;
        this.floatingChatResizing = true;
        if (handle?.setPointerCapture) {
            try {
                handle.setPointerCapture(event.pointerId);
            } catch (_error) { }
        }
        this.floatingResizeMoveListener = (moveEvent: PointerEvent) => this.resizeFloatingChat(moveEvent);
        this.floatingResizeEndListener = (endEvent: PointerEvent) => this.finishFloatingChatResize(endEvent);
        window.addEventListener('pointermove', this.floatingResizeMoveListener);
        window.addEventListener('pointerup', this.floatingResizeEndListener);
        window.addEventListener('pointercancel', this.floatingResizeEndListener);
        void this.service.render();
    }

    public async handleFloatingChatResizeKeydown(event: KeyboardEvent) {
        if (!this.floatingChatResizeEnabled()) return;
        const step = event.shiftKey ? 40 : 16;
        let handled = true;
        if (event.key === 'ArrowLeft') this.floatingChatWidth += step;
        else if (event.key === 'ArrowRight') this.floatingChatWidth -= step;
        else if (event.key === 'ArrowUp') this.floatingChatHeight += step;
        else if (event.key === 'ArrowDown') this.floatingChatHeight -= step;
        else if (event.key === 'Home') {
            this.floatingChatWidth = this.floatingChatDefaultWidth;
            this.floatingChatHeight = this.floatingChatDefaultHeight;
        } else {
            handled = false;
        }
        if (!handled) return;
        event.preventDefault();
        event.stopPropagation();
        this.clampFloatingChatSize();
        this.persistFloatingChatSize();
        await this.service.render();
    }

    private resizeFloatingChat(event: PointerEvent) {
        if (
            !this.floatingChatResizing
            || !this.floatingResizeStart
            || event.pointerId !== this.floatingResizePointerId
        ) return;
        event.preventDefault();
        this.floatingChatWidth = this.floatingResizeStart.width
            + (this.floatingResizeStart.clientX - event.clientX);
        this.floatingChatHeight = this.floatingResizeStart.height
            + (this.floatingResizeStart.clientY - event.clientY);
        this.clampFloatingChatSize();
        void this.service.render();
    }

    private finishFloatingChatResize(event?: PointerEvent) {
        if (
            event
            && this.floatingResizePointerId !== null
            && event.pointerId !== this.floatingResizePointerId
        ) return;
        const pointerId = this.floatingResizePointerId;
        const handle = this.floatingResizeHandle;
        this.removeFloatingChatResizeListeners();
        if (handle?.releasePointerCapture && pointerId !== null) {
            try {
                if (!handle.hasPointerCapture || handle.hasPointerCapture(pointerId)) {
                    handle.releasePointerCapture(pointerId);
                }
            } catch (_error) { }
        }
        this.floatingResizePointerId = null;
        this.floatingResizeStart = null;
        this.floatingResizeHandle = null;
        const wasResizing = this.floatingChatResizing;
        this.floatingChatResizing = false;
        if (!wasResizing) return;
        this.persistFloatingChatSize();
        void this.service.render();
    }

    private removeFloatingChatResizeListeners() {
        if (typeof window !== 'undefined' && this.floatingResizeMoveListener) {
            window.removeEventListener('pointermove', this.floatingResizeMoveListener);
        }
        if (typeof window !== 'undefined' && this.floatingResizeEndListener) {
            window.removeEventListener('pointerup', this.floatingResizeEndListener);
            window.removeEventListener('pointercancel', this.floatingResizeEndListener);
        }
        this.floatingResizeMoveListener = null;
        this.floatingResizeEndListener = null;
    }

    private floatingChatSizeBounds() {
        const viewportWidth = typeof window === 'undefined' ? 1440 : window.innerWidth;
        const viewportHeight = typeof window === 'undefined' ? 900 : window.innerHeight;
        const maximumWidth = Math.max(280, viewportWidth - 44);
        const maximumHeight = Math.max(360, viewportHeight - 44);
        return {
            minimumWidth: Math.min(this.floatingChatMinimumWidth, maximumWidth),
            minimumHeight: Math.min(this.floatingChatMinimumHeight, maximumHeight),
            maximumWidth,
            maximumHeight
        };
    }

    private clampFloatingChatSize() {
        if (!this.floatingChatResizeEnabled()) return false;
        const beforeWidth = this.floatingChatWidth;
        const beforeHeight = this.floatingChatHeight;
        const bounds = this.floatingChatSizeBounds();
        this.floatingChatWidth = Math.round(Math.max(
            bounds.minimumWidth,
            Math.min(bounds.maximumWidth, Number(this.floatingChatWidth) || this.floatingChatDefaultWidth)
        ));
        this.floatingChatHeight = Math.round(Math.max(
            bounds.minimumHeight,
            Math.min(bounds.maximumHeight, Number(this.floatingChatHeight) || this.floatingChatDefaultHeight)
        ));
        return beforeWidth !== this.floatingChatWidth || beforeHeight !== this.floatingChatHeight;
    }

    private restoreFloatingChatSize() {
        if (typeof localStorage === 'undefined') return;
        try {
            const saved = JSON.parse(localStorage.getItem(this.floatingChatSizeStorageKey) || '{}');
            if (Number.isFinite(Number(saved?.width))) this.floatingChatWidth = Number(saved.width);
            if (Number.isFinite(Number(saved?.height))) this.floatingChatHeight = Number(saved.height);
            this.clampFloatingChatSize();
        } catch (_error) {
            this.floatingChatWidth = this.floatingChatDefaultWidth;
            this.floatingChatHeight = this.floatingChatDefaultHeight;
        }
    }

    private persistFloatingChatSize() {
        if (typeof localStorage === 'undefined' || !this.floatingChatResizeEnabled()) return;
        try {
            localStorage.setItem(this.floatingChatSizeStorageKey, JSON.stringify({
                width: this.floatingChatWidth,
                height: this.floatingChatHeight
            }));
        } catch (_error) { }
    }

    public async toggleFloatingChat(event?: Event) {
        if (event) event.stopPropagation();
        this.floatingChatOpen = !this.floatingChatOpen;
        if (this.floatingChatOpen) this.alsphereChat.resume();
        else this.alsphereChat.abort();
        await this.service.render();
        if (this.floatingChatOpen) this.scrollFloatingChatToLatestMessage();
    }

    public async closeFloatingChat(event?: Event) {
        this.alsphereChat.abort();
        void this.persistSharedConversation();
        if (event) event.stopPropagation();
        this.floatingChatOpen = false;
        await this.service.render();
    }

    public async resetFloatingChat() {
        if (this.locked) return;
        this.interruptFloatingRequest();
        if (this.floatingChatMessages.some(item => item?.role === 'user')) void this.persistSharedConversation();
        this.alsphereChat.reset();
        this.cancelFloatingSourceRequests();
        this.floatingAskSeq++;
        if (this.floatingActiveController) this.floatingActiveController.abort();
        this.floatingActiveController = null;
        this.clearFloatingTimers();
        this.floatingChatMessages = [{
            role: 'assistant',
            content: '새 연구 질문을 입력해 주세요. 문맥이나 조건이 모호한 경우에만 확인을 요청합니다.',
            followups: this.floatingExampleQuestions.map(item => item.text)
        }];
        this.floatingChatInput = '';
        this.floatingAgentMode = 'auto';
        this.floatingToolExecutionMode = 'auto';
        this.floatingChatAsking = false;
        this.floatingPendingAgentRequest = null;
        this.resetFloatingConversationEnvelopeForReanalysis();
        chatSession.newConversation(this);
        this.sharedSnapshot = chatSession.current;
        await this.persistSharedConversation();
        await this.service.render();
    }

    public async selectFloatingSuggestion(text: string) {
        if (this.locked) return;
        if (this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        const example = this.floatingExampleQuestions.find(item => item.text === text);
        if (example) this.floatingAgentMode = example.agentMode;
        this.floatingChatInput = text;
        await this.floatingChatAsk();
    }

    public async floatingChatAsk() {
        if (this.locked) return;
        const message = String(this.floatingChatInput || '').trim();
        if ((!message && !this.alsphereChat.file) || this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        if (await this.alsphereChat.trySend(message)) { await this.persistSharedConversation(); return; }

        const context = this.floatingConversationContext();
        const requestedAgentMode = this.floatingAgentMode;
        const requestedToolExecutionMode = this.floatingToolExecutionMode;
        const progressMessage: any = this.createFloatingProgressMessage(message);
        const seq = ++this.floatingAskSeq;
        const controller = this.beginFloatingAskRequest();
        this.floatingLastQuestion = message;
        this.floatingChatMessages.push({ role: 'user', content: message });
        this.floatingChatMessages.push(progressMessage);
        this.floatingChatInput = '';
        this.floatingChatAsking = true;
        this.trimFloatingChatMessages();
        void this.persistSharedConversation();
        await this.service.render();
        this.service.chatPresentation.scrollToProcessStart(this.element.nativeElement.querySelector('.nf-floating-chat-body'));

        try {
            const plan = await this.prepareFloatingAnswerPlan(
                message,
                context,
                progressMessage,
                seq,
                controller,
                requestedAgentMode,
                requestedToolExecutionMode
            );
            if (seq !== this.floatingAskSeq || controller.signal.aborted) return;
            await this.applyFloatingPreparedAnswerPlan(
                message,
                context,
                progressMessage,
                plan,
                requestedAgentMode,
                requestedToolExecutionMode,
                seq,
                controller
            );
        } catch (error: any) {
            if (error?.name === 'AbortError') return;
            const conversationConflict = this.floatingConversationConflictFromError(error);
            let conversationConflictHandled = false;
            if (conversationConflict) {
                conversationConflictHandled = await this.replanFloatingAnswerAfterConversationConflict(
                    message,
                    context,
                    progressMessage,
                    seq,
                    controller,
                    requestedAgentMode,
                    requestedToolExecutionMode,
                    '의도 분석을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.'
                );
            }
            if (!conversationConflictHandled) {
                Object.assign(progressMessage, {
                    role: 'error',
                    content: this.floatingErrorMessage(
                        error,
                        '의도 분석을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.',
                        conversationConflict
                    ),
                    question: message,
                    processing: false,
                    retryable: true,
                    contextConflict: conversationConflict,
                    generationProcess: null
                });
                this.floatingPendingAgentRequest = null;
            }
        }

        this.finishFloatingAskRequest(seq, controller);
        this.trimFloatingChatMessages();
        await this.service.render();
        this.scrollFloatingChatToLatestMessage();
    }

    public async confirmFloatingIntent(message: any) {
        if (this.locked) return;
        const pending = this.floatingPendingAgentRequest;
        if (
            this.floatingChatAsking
            || !pending
            || pending.progressMessage !== message
            || message?.intentReview?.status !== 'awaiting'
        ) return;

        message.intentReview.status = 'confirmed';
        message.processing = true;
        message.answerFlow = this.resumeFloatingAnswerFlowAfterReview(message.answerFlow);
        const seq = ++this.floatingAskSeq;
        const controller = this.beginFloatingAskRequest();
        const confirmedAgentMode = String(message.intentReview.agentMode || pending.reviewedAgentMode || pending.requestedAgentMode || 'simple');
        const confirmedToolExecutionMode = this.floatingResolvedToolExecutionMode(
            message.intentReview.toolExecutionMode
            || pending.reviewedToolExecutionMode
            || pending.requestedToolExecutionMode
        );
        const confirmedReview = {
            intent: message.intentReview.intent || 'general',
            intentLabel: message.intentReview.intentLabel || '질문 분석',
            agentMode: confirmedAgentMode,
            agentModeLabel: message.intentReview.agentModeLabel || this.floatingAgentModeTitle(confirmedAgentMode),
            toolExecutionMode: confirmedToolExecutionMode,
            resolvedQuery: message.intentReview.understoodRequest || pending.message,
            secondaryIntents: (message.analysis?.secondaryIntents || []).slice(0, 10),
            skills: (message.intentReview.skills || []).slice(0, 20),
            revisionCount: Number(message.intentReview.revisionCount || 0),
            feedback: String(pending.intentFeedback || '').trim(),
            conversationBinding: this.normalizeFloatingConversationBinding(
                message.intentReview.conversationBinding
                || pending.context?.conversationBinding
            )
        };
        message.generationProcess = this.buildFloatingGenerationProcess(message, message.intentReview);
        this.floatingChatAsking = true;
        this.floatingPendingAgentRequest = null;
        await this.service.render();
        this.scrollFloatingChatToLatestMessage();
        await this.executeFloatingAnswer(
            pending.message,
            pending.context,
            message,
            seq,
            controller,
            confirmedAgentMode,
            pending.requestedToolExecutionMode,
            confirmedReview
        );
    }

    public async requestFloatingIntentRevision(message: any) {
        if (this.locked) return;
        if (this.floatingChatAsking || !this.showFloatingIntentReview(message)) return;
        message.intentReview.status = 'editing';
        message.intentReview.error = '';
        message.intentReview.correctionAgentMode = String(message.intentReview.requestedAgentMode || 'auto');
        message.intentReview.correctionNote = String(message.intentReview.correctionNote || '');
        await this.service.render();
    }

    public async cancelFloatingIntentRevision(message: any) {
        if (this.locked) return;
        if (this.floatingChatAsking || message?.intentReview?.status !== 'editing') return;
        const pending = this.floatingPendingAgentRequest;
        message.intentReview.status = 'awaiting';
        message.intentReview.error = '';
        message.intentReview.correctionNote = pending?.progressMessage === message
            ? String(pending.intentFeedback || '')
            : '';
        await this.service.render();
    }

    public async selectFloatingIntentCorrection(message: any, mode: string) {
        if (this.locked) return;
        if (this.floatingChatAsking || message?.intentReview?.status !== 'editing') return;
        if (!this.floatingAgentModes.some((item: any) => item.id === mode)) return;
        message.intentReview.correctionAgentMode = mode;
        message.intentReview.error = '';
        await this.service.render();
    }

    public canReanalyzeFloatingIntent(message: any) {
        const review = message?.intentReview || {};
        const note = String(review.correctionNote || '').trim();
        const modeChanged = String(review.correctionAgentMode || '') !== String(review.requestedAgentMode || 'auto');
        return Boolean(note || modeChanged);
    }

    public async reanalyzeFloatingIntent(message: any) {
        if (this.locked) return;
        const pending = this.floatingPendingAgentRequest;
        if (
            this.floatingChatAsking
            || !pending
            || pending.progressMessage !== message
            || message?.intentReview?.status !== 'editing'
            || !this.canReanalyzeFloatingIntent(message)
        ) return;

        const requestedAgentMode = String(message.intentReview.correctionAgentMode || 'auto');
        const intentFeedback = String(message.intentReview.correctionNote || '').trim().slice(0, 1000);
        const priorReview = { ...message.intentReview };
        const seq = ++this.floatingAskSeq;
        const controller = this.beginFloatingAskRequest();
        this.floatingChatAsking = true;
        message.processing = true;
        message.intentReview.status = 'analyzing';
        message.intentReview.error = '';
        await this.service.render();

        try {
            const plan = await this.prepareFloatingAnswerPlan(
                pending.message,
                pending.context,
                message,
                seq,
                controller,
                requestedAgentMode,
                pending.requestedToolExecutionMode,
                intentFeedback
            );
            if (seq !== this.floatingAskSeq || controller.signal.aborted) return;
            this.floatingAgentMode = requestedAgentMode;
            await this.applyFloatingPreparedAnswerPlan(
                pending.message,
                pending.context,
                message,
                plan,
                requestedAgentMode,
                pending.requestedToolExecutionMode,
                seq,
                controller,
                {
                    ...priorReview,
                    revisionCount: Number(priorReview.revisionCount || 0) + 1
                },
                intentFeedback
            );
        } catch (error: any) {
            if (error?.name === 'AbortError') return;
            const conversationConflict = this.floatingConversationConflictFromError(error);
            if (conversationConflict) {
                this.resetFloatingConversationEnvelopeForReanalysis(message);
                priorReview.conversationBinding = null;
            }
            message.processing = false;
            message.generationProcess = null;
            message.intentReview = {
                ...priorReview,
                status: 'editing',
                correctionAgentMode: requestedAgentMode,
                conversationBinding: conversationConflict ? null : priorReview.conversationBinding,
                error: this.floatingErrorMessage(
                    error,
                    '의도를 다시 분석하지 못했습니다. 잠시 후 재시도해 주세요.',
                    conversationConflict
                )
            };
            message.answerFlow = this.holdFloatingAnswerFlowForReview(message.answerFlow);
        }

        this.finishFloatingAskRequest(seq, controller);
        await this.service.render();
        this.scrollFloatingChatToLatestMessage();
    }

    public async cancelFloatingAsk() {
        if (this.alsphereChat.busy) {
            this.alsphereChat.abort();
            await this.persistSharedConversation();
            await this.service.render();
            return;
        }
        if (!this.floatingChatAsking) {
            this.alsphereChat.abort();
            await this.persistSharedConversation();
            return;
        }
        this.floatingAskSeq++;
        const controller = this.floatingActiveController;
        this.floatingActiveController = null;
        if (controller) controller.abort();
        this.floatingChatAsking = false;
        const activeMessage = [...this.floatingChatMessages].reverse().find((item: any) => item?.processing);
        if (activeMessage) {
            activeMessage.processing = false;
            activeMessage.streaming = false;
            activeMessage.cancelled = true;
            activeMessage.role = 'assistant';
            activeMessage.content = '요청을 중단했습니다. 질문을 수정하거나 재시도할 수 있습니다.';
            activeMessage.answerFlow = this.cancelFloatingAnswerFlow(activeMessage.answerFlow);
            activeMessage.generationProcess = null;
            if (activeMessage.intentReview?.status === 'analyzing') activeMessage.intentReview.status = 'cancelled';
            if (this.floatingPendingAgentRequest?.progressMessage === activeMessage) this.floatingPendingAgentRequest = null;
        }
        await this.persistSharedConversation();
        await this.service.render();
    }

    public async retryFloatingLast() {
        if (this.locked) return;
        if (!this.floatingLastQuestion || this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        this.floatingChatInput = this.floatingLastQuestion;
        await this.floatingChatAsk();
    }

    public async openAgentChatFromFloating() {
        if (this.floatingChatAsking) return;
        await this.persistSharedConversation();
        this.alsphereChat.abort();
        this.service.href('/agent/chat');
        this.floatingChatOpen = false;
        await this.service.render();
    }

    public async openReportStudioFromFloating() {
        this.service.href('/agent/visualization');
        this.floatingChatOpen = false;
        await this.service.render();
    }

    public floatingMessageClass(message: any) {
        if (message?.role === 'user') return 'is-user';
        if (message?.role === 'error') return 'is-error';
        if (this.showFloatingIntentReview(message)) return 'is-review';
        if (this.showFloatingGenerationProcess(message) || this.service.chatPresentation.currentProgress(message)) return 'is-generation';
        return 'is-assistant';
    }

    public async updateFloatingChatInput(value: string) {
        if (this.locked) return;
        this.floatingChatInput = value;
        await this.service.render();
    }

    public handleFloatingChatKeydown(event: KeyboardEvent) {
        if (this.locked) return;
        if (event.key !== 'Enter' || event.shiftKey || (event as any).isComposing) return;
        event.preventDefault();
        void this.floatingChatAsk();
    }

    public floatingRuntimeItems(message: any) {
        const items: any[] = [];
        if (message?.intent && this.floatingResponseComplete(message)) {
            items.push({ label: message.intentLabel || this.floatingIntentLabel(message.intent), tone: 'neutral' });
        }
        const mode = message?.agentMode || message?.analysis?.agentMode;
        if (mode && this.floatingResponseComplete(message)) {
            items.push({ label: this.floatingAgentModeTitle(mode), tone: 'neutral' });
        }
        const toolMode = message?.toolExecutionMode || message?.analysis?.toolExecutionMode;
        if (toolMode && this.floatingResponseComplete(message)) {
            items.push({ label: this.floatingToolExecutionModeLabel(toolMode), tone: 'neutral' });
        }
        const scope = String(message?.dataScope || '');
        if (scope === 'sample') {
            items.push({ label: `샘플 데이터${message?.dataAsOf ? ' · ' + message.dataAsOf + ' 기준' : ''}`, tone: 'sample' });
        } else if (scope === 'no_data') {
            items.push({ label: '일치하는 근거 데이터 없음', tone: 'warning' });
        }
        const references = this.normalizeFloatingResultReferences(message?.resultReferences).length;
        if (references) {
            items.push({ label: `검증 결과 ${references}건`, tone: 'success' });
        }
        if (message?.llm?.fallback === true || message?.llm?.degraded === true) {
            items.push({ label: '대체 응답 사용', tone: 'warning' });
        }
        return items;
    }

    private floatingPayload(data: any) {
        if (data && data.data) return data.data;
        return data || {};
    }

    private floatingAssistantMessage(data: any, question: string) {
        const resultReferences = this.normalizeFloatingResultReferences(
            Array.isArray(data?.resultReferences)
                ? data.resultReferences
                : data?.conversationState?.resultReferences
        );
        const policy = data?.artifactPolicy || this.floatingFallbackArtifactPolicy(data);
        return {
            ...(data || {}),
            role: 'assistant',
            question,
            content: data?.answer || data?.content || '답변을 생성하지 못했습니다.',
            intentReview: null,
            intent: data?.intent || '',
            intentLabel: data?.intentLabel || data?.analysis?.intentLabel || '',
            agentMode: data?.agentMode || data?.analysis?.agentMode || '',
            agentModeLabel: data?.agentModeLabel || data?.analysis?.agentModeLabel || '',
            dataScope: data?.dataScope || '',
            dataAsOf: data?.dataAsOf || '',
            source: data?.source || '',
            llm: data?.llm || null,
            markdown: String(data?.markdown || ''),
            table: data?.table || null,
            chart: data?.chart || null,
            actions: Array.isArray(data?.actions) ? data.actions : null,
            skippedActions: data?.skippedActions || [],
            executionWaveResults: data?.executionWaveResults || data?.orchestration?.pipeline?.executionWaveResults || [],
            requestedToolExecutionMode: data?.requestedToolExecutionMode || data?.analysis?.requestedToolExecutionMode || 'auto',
            toolExecutionMode: data?.toolExecutionMode || data?.analysis?.toolExecutionMode || 'auto',
            toolExecutionPlan: data?.toolExecutionPlan || data?.analysis?.toolExecutionPlan || null,
            executionWaves: data?.executionWaves || data?.analysis?.executionWaves || [],
            answerFlow: data?.answerFlow || null,
            generationProcess: null,
            streaming: false,
            progressNotice: '',
            answerQuality: data?.answerQuality || null,
            orchestration: data?.orchestration || null,
            artifactPolicy: policy,
            resultReferences,
            citations: (data?.citations || []).slice(0, 100),
            deepLinks: (data?.deepLinks || []).slice(0, 3),
            followups: (data?.followups || []).slice(0, 3)
        };
    }

    private createFloatingProgressMessage(question: string) {
        return {
            role: 'assistant',
            content: '',
            question,
            processing: true,
            generationProcess: {
                visibleCount: 5,
                steps: this.service.chatPresentation.initialProcessSteps({ agentMode: this.floatingAgentMode }).map((step: any) => ({
                    ...step, state: step.status, stateLabel: this.service.chatPresentation.progressStatus(step.status)
                }))
            },
            answerFlow: {
                version: 'answer-flow-v1',
                currentStep: 'context',
                steps: [
                    { id: 'context', order: 1, label: '문맥 파악', status: 'running', detail: '최근 대화와 현재 질문의 분석 범위를 확인합니다.' },
                    { id: 'intent', order: 2, label: '의도 분류', status: 'pending', detail: '질문 유형과 Agent 경로를 분류합니다.' },
                    { id: 'skill', order: 3, label: 'Skill 선택', status: 'pending', detail: '필요한 데이터·모델·분석 Skill을 선택합니다.' },
                    { id: 'execute', order: 4, label: 'Agent 실행', status: 'pending', detail: '확인된 전략으로 Agent를 실행합니다.' },
                    { id: 'answer', order: 5, label: '최종 답변', status: 'pending', detail: '근거와 결과를 답변으로 정리합니다.' }
                ]
            }
        };
    }

    public showFloatingGenerationProcess(message: any) {
        return Boolean(
            message?.processing
            && message?.generationProcess?.steps?.length
            && !this.showFloatingIntentReview(message)
            && !this.service.chatPresentation.currentProgress(message)
        );
    }

    public floatingGenerationSteps(message: any) {
        const process = message?.generationProcess;
        const steps = Array.isArray(process?.steps) ? process.steps : [];
        const visibleCount = Math.max(0, Math.min(steps.length, Number(process?.visibleCount) || 0));
        return steps.slice(0, visibleCount);
    }

    public showFloatingLoadingDots() {
        return Boolean(
            this.floatingChatAsking
            && !(this.floatingChatMessages || []).some((message: any) => this.showFloatingGenerationProcess(message)
                || this.service.chatPresentation.currentProgress(message))
        );
    }

    private buildFloatingGenerationProcess(plan: any, intentReview: any) {
        const analysis = plan?.analysis || plan || {};
        const contextSummary = String(
            intentReview?.contextSummary
            || analysis?.contextSummary
            || ''
        ).replace(/\s+/g, ' ').trim().slice(0, 180);
        const understoodRequest = String(
            intentReview?.understoodRequest
            || analysis?.resolvedQuery
            || plan?.question
            || ''
        ).replace(/\s+/g, ' ').trim().slice(0, 220);
        const waves = this.floatingExecutionWaves({
            executionWaves: intentReview?.executionWaves || plan?.executionWaves || analysis?.executionWaves || []
        });
        const plannedTools = waves.reduce((items: string[], wave: any) => {
            (wave.tools || []).forEach((tool: string) => {
                const label = this.floatingSkillLabel(tool);
                if (label && !items.includes(label)) items.push(label);
            });
            return items;
        }, []);
        const skills = intentReview?.skills || plan?.skillPlan || analysis?.tools || [];
        (Array.isArray(skills) ? skills : []).slice(0, 20).forEach((tool: string) => {
            const label = this.floatingSkillLabel(tool);
            if (label && !plannedTools.includes(label)) plannedTools.push(label);
        });
        const resultAnalysis = this.service.chatPresentation.resultAnalysisStep(intentReview || plan);
        const dataSearch = this.service.chatPresentation.isDataSearch(intentReview || plan);
        const toolSteps = [{ id: 'tools', label: 'Tool 실행', state: 'waiting', stateLabel: '대기', detail: '서버 실행 상태를 기다리고 있습니다.' }];
        return {
            visibleCount: 5,
            steps: [
                {
                    id: 'context',
                    label: '문맥 분석',
                    state: 'analyzed',
                    stateLabel: '분석됨',
                    detail: contextSummary || (
                        intentReview?.contextUsed
                            ? '최근 대화에서 질문에 필요한 문맥을 연결했습니다.'
                            : '현재 질문을 독립적인 연구 질의로 분석했습니다.'
                    )
                },
                {
                    id: 'intent',
                    label: '의도 파악',
                    state: 'analyzed',
                    stateLabel: '분석됨',
                    detail: `${intentReview?.intentLabel || this.floatingIntentLabel(plan?.intent || analysis?.intent)}${understoodRequest ? ` · ${understoodRequest}` : ''}`
                },
                {
                    id: 'parameters',
                    label: '파라미터 구분',
                    state: 'analyzed',
                    stateLabel: '구분됨',
                    detail: this.floatingParameterSummary(intentReview?.entities || analysis?.entities)
                },
                ...toolSteps,
                {
                    id: 'answer',
                    label: resultAnalysis.label,
                    state: 'waiting',
                    stateLabel: '응답 대기',
                    detail: dataSearch ? resultAnalysis.detail : plannedTools.length
                        ? 'Tool 결과가 도착하면 근거를 분석하고 질의 언어에 맞춰 답변을 요약합니다.'
                        : '추가 Tool 없이 확인된 문맥과 근거를 분석해 질의 언어에 맞춰 답변을 작성합니다.'
                }
            ]
        };
    }

    private floatingParameterSummary(entities: any) {
        if (!entities || typeof entities !== 'object' || Array.isArray(entities)) {
            return '별도 파라미터 없이 일반 설명 범위로 구분했습니다.';
        }
        const labels: any = {
            lot: 'Lot',
            lots: 'Lot',
            process: '공정',
            processes: '공정',
            equipment: '설비',
            equipments: '설비',
            metric: '지표',
            metrics: '지표',
            target: '대상',
            recipe: 'Recipe',
            timeRange: '기간',
            periods: '기간',
            parameter: '파라미터',
            parameters: '파라미터',
            analysisItems: '분석 항목'
        };
        const entries = Object.keys(entities).slice(0, 6).map((key: string) => {
            const value = this.normalizeFloatingParameterValue(entities[key]);
            const normalized = value.replace(/\s+/g, ' ').trim().slice(0, 90);
            return normalized ? `${labels[key] || key}: ${normalized}` : '';
        }).filter(Boolean);
        return entries.length
            ? entries.join(' · ')
            : '질문에서 명시된 별도 파라미터가 없어 일반 설명 범위로 구분했습니다.';
    }

    private normalizeFloatingParameterValue(value: any): string {
        if (value === null || value === undefined || value === '') return '';
        if (Array.isArray(value)) {
            return value.slice(0, 4)
                .map((item: any) => this.normalizeFloatingParameterValue(item))
                .filter(Boolean)
                .join(', ');
        }
        if (typeof value !== 'object') return String(value);
        const primary = ['label', 'name', 'key', 'id', 'value']
            .map((key: string) => value[key])
            .find((item: any) => ['string', 'number'].includes(typeof item) && String(item).trim());
        const start = value.start ?? value.startDate ?? value.from;
        const end = value.end ?? value.endDate ?? value.to;
        const range = [start, end]
            .filter((item: any) => ['string', 'number'].includes(typeof item) && String(item).trim())
            .map((item: any) => String(item).trim())
            .join('~');
        if (primary || range) return [primary, range].filter(Boolean).join(' ');
        return Object.keys(value).slice(0, 4).map((key: string) => {
            const item = value[key];
            if (!['string', 'number', 'boolean'].includes(typeof item)) return '';
            return `${key}: ${String(item)}`;
        }).filter(Boolean).join(', ');
    }

    private waitForFloatingDelay(delay: number) {
        if (this.floatingDestroyed) return Promise.resolve();
        return new Promise<void>((resolve) => {
            let settled = false;
            const record: any = {
                id: null,
                cancel: () => {
                    if (settled) return;
                    settled = true;
                    resolve();
                }
            };
            record.id = setTimeout(() => {
                this.floatingTimers.delete(record);
                record.cancel();
            }, delay);
            this.floatingTimers.add(record);
        });
    }

    private scheduleFloatingTimer(callback: () => void, delay: number, onCancel?: () => void) {
        if (this.floatingDestroyed) {
            if (onCancel) onCancel();
            return;
        }
        const record: any = { id: null, cancel: onCancel || null };
        record.id = setTimeout(() => {
            this.floatingTimers.delete(record);
            callback();
        }, delay);
        this.floatingTimers.add(record);
    }

    private clearFloatingTimers() {
        this.floatingTimers.forEach((record: any) => {
            clearTimeout(record.id);
            if (record.cancel) {
                try {
                    record.cancel();
                } catch (_error) { }
            }
        });
        this.floatingTimers.clear();
    }

    private beginFloatingAskRequest() {
        if (this.floatingActiveController) this.floatingActiveController.abort();
        this.floatingActiveController = new AbortController();
        return this.floatingActiveController;
    }

    private finishFloatingAskRequest(seq: number, controller: AbortController) {
        if (seq !== this.floatingAskSeq || this.floatingActiveController !== controller) return;
        this.floatingActiveController = null;
        this.floatingChatAsking = false;
        void this.persistSharedConversation();
    }

    private async prepareFloatingAnswerPlan(
        message: string,
        context: any,
        progressMessage: any,
        seq: number,
        controller: AbortController,
        requestedAgentMode: string,
        requestedToolExecutionMode: string,
        intentFeedback: string = ''
    ) {
        const formData = this.guestChatForm();
        formData.append('message', message);
        formData.append('source', this.inline ? 'chat' : 'floating');
        formData.append('context', JSON.stringify(context || { messages: [] }));
        formData.append('agent_mode', requestedAgentMode || 'auto');
        formData.append('tool_execution_mode', requestedToolExecutionMode || 'auto');
        if (intentFeedback) formData.append('intent_feedback', intentFeedback);
        const response = await fetch('/wiz/api/page.agent/plan_answer', {
            method: 'POST',
            body: formData,
            signal: controller.signal
        });
        const envelope = await this.readFloatingJson(response, '의도 분석 응답을 해석하지 못했습니다.');
        if (!response.ok || Number(envelope?.code) !== 200) {
            throw this.floatingRequestError(envelope, response.status, '의도 분석을 완료하지 못했습니다.');
        }
        if (seq !== this.floatingAskSeq || controller.signal.aborted || !progressMessage?.processing) return null;
        const plan = this.floatingPayload(envelope.data);
        const binding = this.applyFloatingServerConversationEnvelope(plan);
        if (binding) plan.conversationBinding = binding;
        progressMessage.intent = plan?.intent;
        progressMessage.analysis = plan?.analysis;
        progressMessage.toolExecutionMode = plan?.toolExecutionMode || plan?.analysis?.toolExecutionMode || requestedToolExecutionMode;
        progressMessage.toolExecutionPlan = plan?.toolExecutionPlan || plan?.analysis?.toolExecutionPlan || null;
        progressMessage.executionWaves = plan?.executionWaves || plan?.analysis?.executionWaves || [];
        progressMessage.answerFlow = this.prepareFloatingAnswerFlowForReview(plan?.answerFlow || progressMessage.answerFlow);
        return plan;
    }

    private async executeFloatingAnswer(
        message: string,
        context: any,
        progressMessage: any,
        seq: number,
        controller: AbortController,
        requestedAgentMode: string,
        requestedToolExecutionMode: string,
        confirmedReview: any = null,
        intentFeedback: string = '',
        allowConversationReplan: boolean = true
    ) {
        try {
            const formData = this.guestChatForm();
            formData.append('message', message);
            formData.append('source', this.inline ? 'chat' : 'floating');
            formData.append('context', JSON.stringify(context || { messages: [] }));
            formData.append('agent_mode', requestedAgentMode || 'auto');
            formData.append('tool_execution_mode', requestedToolExecutionMode || 'auto');
            if (confirmedReview) {
                formData.append('confirmed_review', JSON.stringify(confirmedReview));
            }
            const executionFeedback = String(confirmedReview?.feedback || intentFeedback || '').trim();
            if (executionFeedback) formData.append('intent_feedback', executionFeedback);
            const responsePromise = this.service.chatPresentation.fetchWithProgress('/wiz/api/page.agent/ask', {
                method: 'POST',
                body: formData,
                signal: controller.signal
            }, (snapshot: any) => {
                if (seq !== this.floatingAskSeq || controller.signal.aborted) return;
                const scroll = this.service.chatPresentation.progressScroll(
                    this.element.nativeElement.querySelector('.nf-floating-chat-body'), progressMessage, snapshot
                );
                this.service.chatPresentation.applyProgress(progressMessage, snapshot);
                void this.service.render().then(() => {
                    if (seq === this.floatingAskSeq && !controller.signal.aborted) scroll();
                });
            }).then(
                (response: Response) => ({ response, error: null }),
                (error: any) => ({ response: null, error })
            );
            const responseResult = await responsePromise;
            if (responseResult.error) throw responseResult.error;
            const response = responseResult.response as Response;
            const envelope = await this.readFloatingJson(response, '서버 응답을 해석하지 못했습니다.');
            if (!response.ok || Number(envelope?.code) !== 200) {
                throw this.floatingRequestError(envelope, response.status, '질의를 처리하지 못했습니다.');
            }
            if (seq !== this.floatingAskSeq || controller.signal.aborted) return;
            const data = this.floatingPayload(envelope.data);
            this.applyFloatingServerConversationEnvelope(data);
            Object.assign(progressMessage, this.floatingAssistantMessage(data, message), { processing: false });
        } catch (error: any) {
            if (error?.name === 'AbortError') return;
            const conversationConflict = this.floatingConversationConflictFromError(error);
            if (conversationConflict && allowConversationReplan) {
                const replanned = await this.replanFloatingAnswerAfterConversationConflict(
                    message,
                    context,
                    progressMessage,
                    seq,
                    controller,
                    requestedAgentMode,
                    requestedToolExecutionMode,
                    '질의를 처리하지 못했습니다. 입력값을 확인해 주세요.'
                );
                if (replanned) return;
            }
            // The server may have claimed the confirmed turn before a
            // transport error hid its response. Always force a fresh plan.
            this.resetFloatingConversationEnvelopeForReanalysis(progressMessage);
            Object.assign(progressMessage, {
                role: 'error',
                content: this.floatingErrorMessage(
                    error,
                    '질의를 처리하지 못했습니다. 입력값을 확인해 주세요.',
                    conversationConflict
                ),
                question: message,
                processing: false,
                retryable: typeof error?.retryable === 'boolean'
                    ? error.retryable
                    : !error?.blocking,
                contextConflict: conversationConflict,
                generationProcess: null
            });
        } finally {
            this.finishFloatingAskRequest(seq, controller);
            if (!this.floatingDestroyed) {
                await this.service.render();
                this.scrollFloatingChatToLatestMessage();
            }
        }
    }

    private async applyFloatingPreparedAnswerPlan(
        message: string,
        context: any,
        progressMessage: any,
        plan: any,
        requestedAgentMode: string,
        requestedToolExecutionMode: string,
        seq: number,
        controller: AbortController,
        priorReview: any = null,
        intentFeedback: string = '',
        allowConversationReplan: boolean = true
    ) {
        const intentReview = this.buildFloatingIntentReview(
            plan,
            requestedAgentMode,
            requestedToolExecutionMode,
            priorReview
        );
        const boundContext = this.floatingContextWithConversationBinding(
            context,
            intentReview.conversationBinding
        );
        progressMessage.role = 'assistant';
        progressMessage.content = '';
        progressMessage.retryable = false;
        progressMessage.contextConflict = false;
        progressMessage.intent = plan?.intent;
        progressMessage.analysis = plan?.analysis;
        progressMessage.toolExecutionMode = intentReview.toolExecutionMode;
        progressMessage.toolExecutionPlan = plan?.toolExecutionPlan || plan?.analysis?.toolExecutionPlan || null;
        progressMessage.executionWaves = intentReview.executionWaves;

        if (this.floatingPlanRequiresUserReview(plan)) {
            progressMessage.processing = false;
            progressMessage.intentReview = intentReview;
            progressMessage.generationProcess = null;
            progressMessage.answerFlow = this.holdFloatingAnswerFlowForReview(plan?.answerFlow || progressMessage.answerFlow);
            this.floatingPendingAgentRequest = {
                message,
                context: boundContext,
                progressMessage,
                requestedAgentMode,
                requestedToolExecutionMode,
                reviewedAgentMode: intentReview.agentMode,
                reviewedToolExecutionMode: intentReview.toolExecutionMode,
                intentFeedback
            };
            return;
        }

        progressMessage.processing = true;
        progressMessage.intentReview = null;
        progressMessage.generationProcess = this.buildFloatingGenerationProcess(plan, intentReview);
        progressMessage.answerFlow = this.resumeFloatingAnswerFlowAfterReview(plan?.answerFlow || progressMessage.answerFlow);
        this.floatingPendingAgentRequest = null;
        await this.service.render();
        this.scrollFloatingChatToLatestMessage();
        await this.executeFloatingAnswer(
            message,
            boundContext,
            progressMessage,
            seq,
            controller,
            requestedAgentMode,
            requestedToolExecutionMode,
            null,
            intentFeedback,
            allowConversationReplan
        );
    }

    private async replanFloatingAnswerAfterConversationConflict(
        message: string,
        context: any,
        progressMessage: any,
        seq: number,
        controller: AbortController,
        requestedAgentMode: string,
        requestedToolExecutionMode: string,
        fallbackMessage: string
    ) {
        this.resetFloatingConversationEnvelopeForReanalysis(progressMessage);
        const freshContext = this.floatingContextWithConversationBinding(context || { messages: [] }, null);
        const freshProgress = this.createFloatingProgressMessage(message);
        Object.assign(progressMessage, {
            role: 'assistant',
            content: '',
            processing: true,
            retryable: false,
            contextConflict: false,
            intentReview: null,
            question: message,
            answerFlow: freshProgress.answerFlow,
            generationProcess: null
        });
        await this.service.render();
        this.scrollFloatingChatToLatestMessage();

        try {
            const plan = await this.prepareFloatingAnswerPlan(
                message,
                freshContext,
                progressMessage,
                seq,
                controller,
                requestedAgentMode,
                requestedToolExecutionMode
            );
            if (seq !== this.floatingAskSeq || controller.signal.aborted || !progressMessage?.processing) return true;
            await this.applyFloatingPreparedAnswerPlan(
                message,
                freshContext,
                progressMessage,
                plan,
                requestedAgentMode,
                requestedToolExecutionMode,
                seq,
                controller,
                null,
                '',
                false
            );
            return true;
        } catch (retryError: any) {
            if (retryError?.name === 'AbortError' || seq !== this.floatingAskSeq || controller.signal.aborted) return true;
            const retryConflict = this.floatingConversationConflictFromError(retryError);
            if (retryConflict) this.resetFloatingConversationEnvelopeForReanalysis(progressMessage);
            Object.assign(progressMessage, {
                role: 'error',
                content: this.floatingErrorMessage(retryError, fallbackMessage, retryConflict),
                question: message,
                processing: false,
                retryable: true,
                contextConflict: retryConflict,
                generationProcess: null
            });
            this.floatingPendingAgentRequest = null;
            return true;
        }
    }

    private async readFloatingJson(response: Response, fallbackMessage: string) {
        try {
            return await response.json();
        } catch (_error) {
            throw new Error(response.ok ? fallbackMessage : `${fallbackMessage} (${response.status})`);
        }
    }

    private floatingRequestError(envelope: any, status: number, fallbackMessage: string) {
        const error: any = new Error(
            envelope?.data?.message
            || envelope?.data?.error?.message
            || envelope?.message
            || `${fallbackMessage} (${status})`
        );
        error.code = envelope?.data?.error?.code || envelope?.data?.code || '';
        error.action = envelope?.data?.error?.details?.action
            || envelope?.data?.details?.action
            || '';
        const retryable = envelope?.data?.error?.details?.retryable
            ?? envelope?.data?.details?.retryable;
        if (typeof retryable === 'boolean') error.retryable = retryable;
        error.provider = String(
            envelope?.data?.error?.details?.provider
            || envelope?.data?.details?.provider
            || ''
        ).trim().toLowerCase();
        error.conversationInvalidated = (
            envelope?.data?.error?.details?.conversationInvalidated === true
            || envelope?.data?.details?.conversationInvalidated === true
        );
        error.status = status;
        error.blocking = [400, 401, 403, 409, 413, 415, 422].includes(Number(status));
        return error;
    }

    private isFloatingConversationConflictCode(code: any) {
        return [
            'CONTEXT_BINDING_INVALID',
            'CONTEXT_STATE_NOT_FOUND',
            'CONTEXT_REVISION_CONFLICT',
            'CONTEXT_TURN_NOT_PLANNED',
            'EXECUTION_REQUEST_FINGERPRINT_MISMATCH',
            'CONVERSATION_BINDING_MISMATCH',
            'AGENT_REVIEW_BINDING_MISMATCH'
        ].includes(String(code || '').trim());
    }

    private floatingConversationConflictFromError(error: any) {
        return Boolean(
            this.isFloatingConversationConflictCode(error?.code)
            || error?.action === 'reanalyze_intent'
        );
    }

    private resetFloatingConversationEnvelopeForReanalysis(message: any = null) {
        this.floatingConversationBinding = null;
        this.floatingConversationState = null;
        this.floatingExecutionRequest = null;
        this.floatingResultReferences = [];
        if (this.floatingPendingAgentRequest?.context) {
            this.floatingPendingAgentRequest.context = this.floatingContextWithConversationBinding(
                this.floatingPendingAgentRequest.context,
                null
            );
        }
        if (message?.intentReview) message.intentReview.conversationBinding = null;
    }

    private floatingErrorMessage(error: any, fallbackMessage: string, conversationConflict: boolean = false) {
        if (conversationConflict) {
            return '서버 대화 상태가 만료되어 새 문맥으로 자동 재분석했지만 실패했습니다. 다시 시도해 주세요.';
        }
        return error?.message || fallbackMessage;
    }

    public floatingRetryLabel() {
        const latest = this.floatingChatMessages[this.floatingChatMessages.length - 1];
        return latest?.role === 'error' && latest?.contextConflict
            ? '최신 문맥으로 다시 분석'
            : '재시도';
    }

    private floatingPlanRequiresUserReview(plan: any) {
        const analysis = plan?.analysis || {};
        const preferredFlags = [
            plan?.requiresUserReview,
            plan?.requires_user_review,
            plan?.reviewRequired,
            plan?.review_required,
            analysis?.requiresUserReview,
            analysis?.requires_user_review,
            analysis?.reviewRequired,
            analysis?.review_required
        ];
        for (const flag of preferredFlags) {
            if (typeof flag === 'boolean') return flag;
        }
        const compatibleFlags = [
            plan?.requiresHumanReview,
            plan?.requires_human_review,
            analysis?.requiresHumanReview,
            analysis?.requires_human_review,
            plan?.humanReview?.required,
            analysis?.humanReview?.required,
            plan?.requiresAgentModeConfirmation,
            analysis?.requiresAgentModeConfirmation
        ];
        for (const flag of compatibleFlags) {
            if (typeof flag === 'boolean') return flag;
        }
        return false;
    }

    private normalizeFloatingReviewReasons(plan: any) {
        const analysis = plan?.analysis || {};
        const sources = [
            plan?.reviewReasons,
            analysis?.reviewReasons,
            plan?.humanReview?.reviewReasons,
            analysis?.humanReview?.reviewReasons
        ];
        let reasons = sources.find((items: any) => Array.isArray(items) && items.length);
        if (!reasons) {
            reasons = [
                ...(Array.isArray(analysis?.ambiguous) ? analysis.ambiguous : []),
                ...(Array.isArray(analysis?.missingInputs) ? analysis.missingInputs : [])
            ];
        }
        const normalized = (Array.isArray(reasons) ? reasons : []).slice(0, 8).map((item: any) => {
            const value = item && typeof item === 'object' && !Array.isArray(item)
                ? item.question || item.message || item.reason || item.type || ''
                : item;
            if (!['string', 'number'].includes(typeof value)) return '';
            return String(value).replace(/\s+/g, ' ').trim().slice(0, 300);
        }).filter(Boolean);
        return normalized.filter((reason: string, index: number) => normalized.indexOf(reason) === index);
    }

    private buildFloatingIntentReview(
        plan: any,
        requestedAgentMode: string,
        requestedToolExecutionMode: string,
        prior: any = null
    ) {
        const analysis = plan?.analysis || {};
        const executionContract = plan?.toolExecution
            || analysis?.toolExecution
            || plan?.executionPlan
            || analysis?.executionPlan
            || {};
        const resolvedMode = this.floatingResolvedAgentMode(
            plan?.agentMode || analysis?.agentMode,
            plan?.intent || analysis?.intent,
            requestedAgentMode
        );
        const executionWaves = plan?.executionWaves
            || analysis?.executionWaves
            || executionContract?.waves
            || plan?.toolExecutionPlan?.waves
            || analysis?.toolExecutionPlan?.waves
            || [];
        const skills = plan?.skillPlan || analysis?.tools || plan?.toolExecutionPlan?.tools || [];
        const resolvedToolExecutionMode = this.floatingResolvedToolExecutionMode(
            plan?.resolvedToolExecutionMode
            || plan?.toolExecutionMode
            || analysis?.resolvedToolExecutionMode
            || analysis?.toolExecutionMode
            || executionContract?.resolvedMode
            || executionContract?.mode
            || (Array.isArray(executionWaves) && executionWaves.some((wave: any) => (wave.tools || wave || []).length > 1) ? 'parallel' : '')
        );
        return {
            status: 'awaiting',
            requestedAgentMode,
            correctionAgentMode: requestedAgentMode === 'auto' ? resolvedMode : requestedAgentMode,
            agentMode: resolvedMode,
            agentModeLabel: plan?.agentModeLabel || analysis?.agentModeLabel || this.floatingAgentModeTitle(resolvedMode),
            agentModeSource: plan?.agentModeSource || analysis?.agentModeSource || (requestedAgentMode === 'auto' ? 'auto' : 'explicit'),
            intent: plan?.intent || analysis?.intent || 'general',
            intentLabel: plan?.intentLabel || analysis?.intentLabel || this.floatingIntentLabel(plan?.intent || analysis?.intent),
            taskTypeLabel: plan?.taskTypeLabel || analysis?.taskTypeLabel || '질문 유형',
            understoodRequest: analysis?.resolvedQuery || analysis?.normalizedQuery || plan?.question || '',
            entities: analysis?.entities || {},
            skills: Array.isArray(skills) ? skills : [],
            dataSource: analysis?.dataSource || (
                resolvedMode === 'data_search' ? 'BANDI 공정·장비·Lot 데이터'
                    : resolvedMode === 'simple' ? '승인된 문서·도메인 지식'
                    : '등록된 공정·모델 데이터'
            ),
            executionMode: this.floatingExecutionModeSummary(resolvedMode),
            requestedToolExecutionMode,
            toolExecutionMode: resolvedToolExecutionMode,
            executionWaves: Array.isArray(executionWaves) ? executionWaves : [],
            contextUsed: Boolean(analysis?.contextUsed),
            contextSummary: String(analysis?.contextSummary || ''),
            contextResolutionStatus: String(analysis?.contextResolutionStatus || 'standalone'),
            reviewReasons: this.normalizeFloatingReviewReasons(plan),
            conversationBinding: this.normalizeFloatingConversationBinding(
                plan?.conversationBinding || analysis?.conversationBinding
            ),
            requiresVisualization: Boolean(plan?.requiresVisualization || analysis?.requiresVisualization),
            planFallback: Boolean(plan?.planFallback),
            error: '',
            correctionNote: String(prior?.correctionNote || ''),
            revisionCount: Number(prior?.revisionCount || 0)
        };
    }

    private prepareFloatingAnswerFlowForReview(answerFlow: any) {
        if (!answerFlow?.steps?.length) return answerFlow;
        return {
            ...answerFlow,
            steps: answerFlow.steps.map((step: any) => ({
                ...step,
                status: ['context', 'intent', 'skill'].includes(step.id) ? 'completed' : step.status
            }))
        };
    }

    private holdFloatingAnswerFlowForReview(answerFlow: any) {
        if (!answerFlow?.steps?.length) return answerFlow;
        return {
            ...answerFlow,
            currentStep: 'review',
            reviewStatus: 'awaiting_confirmation',
            steps: answerFlow.steps.map((step: any) => ({
                ...step,
                status: ['context', 'intent', 'skill'].includes(step.id) ? 'completed' : 'pending'
            }))
        };
    }

    private resumeFloatingAnswerFlowAfterReview(answerFlow: any) {
        if (!answerFlow?.steps?.length) return answerFlow;
        return {
            ...answerFlow,
            currentStep: 'execute',
            reviewStatus: 'confirmed',
            steps: answerFlow.steps.map((step: any) => ({
                ...step,
                status: ['context', 'intent', 'skill'].includes(step.id)
                    ? 'completed'
                    : step.id === 'execute' ? 'running' : 'pending'
            }))
        };
    }

    private cancelFloatingAnswerFlow(answerFlow: any) {
        if (!answerFlow?.steps?.length) return answerFlow;
        return {
            ...answerFlow,
            currentStep: 'cancelled',
            steps: answerFlow.steps.map((step: any) => ({
                ...step,
                status: ['running', 'pending'].includes(step.status) ? 'cancelled' : step.status
            }))
        };
    }

    private floatingResolvedAgentMode(value: any, intent: any = '', requestedAgentMode: string = 'auto') {
        const mode = String(value || '').trim();
        if (['data_search', 'simple', 'ai_model'].includes(mode)) return mode;
        if (['virtual_metrology', 'anomaly'].includes(mode)) return 'ai_model';
        if (requestedAgentMode && requestedAgentMode !== 'auto') return requestedAgentMode;
        const normalizedIntent = String(intent || '').toLowerCase();
        if (normalizedIntent === 'search') return 'data_search';
        if (['predict', 'optimize', 'anomaly', 'compare', 'spc'].includes(normalizedIntent)) return 'ai_model';
        return 'simple';
    }

    private floatingResolvedToolExecutionMode(value: any) {
        const mode = String(value || '').toLowerCase();
        if (mode === 'parallel' || mode === 'sequential') return mode;
        return 'sequential';
    }

    private floatingExecutionModeSummary(mode: string) {
        if (mode === 'data_search') return '공정 데이터 조회 후 LLM 해석·요약';
        if (['ai_model', 'virtual_metrology', 'anomaly'].includes(mode)) return '질문에 맞는 AI 모델 실행 후 LLM 해석';
        return 'RAG 검색·Instruction 응답';
    }

    private normalizeFloatingConversationBinding(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
        const conversationId = String(value.conversationId || '').trim().toLowerCase();
        const turnId = String(value.turnId || '').trim().toLowerCase();
        const contextFingerprint = String(value.contextFingerprint || '').trim().toLowerCase();
        const executionRequestFingerprint = String(value.executionRequestFingerprint || '').trim().toLowerCase();
        const contextRevision = Number(value.contextRevision);
        if (
            !/^conv-[0-9a-f]{32}$/.test(conversationId)
            || !/^turn-[0-9a-f]{32}$/.test(turnId)
            || !Number.isSafeInteger(contextRevision)
            || contextRevision < 0
            || !/^[0-9a-f]{64}$/.test(contextFingerprint)
            || !/^[0-9a-f]{64}$/.test(executionRequestFingerprint)
        ) return null;
        return { conversationId, turnId, contextRevision, contextFingerprint, executionRequestFingerprint };
    }

    private floatingContextWithConversationBinding(context: any, binding: any) {
        const output: any = {
            messages: Array.isArray(context?.messages) ? context.messages : []
        };
        const normalized = this.normalizeFloatingConversationBinding(binding);
        if (normalized) output.conversationBinding = normalized;
        return output;
    }

    private cloneFloatingServerEnvelopeValue(value: any, maximumLength: number = 65536) {
        if (value === null || value === undefined) return null;
        try {
            const serialized = JSON.stringify(value);
            if (!serialized || serialized.length > maximumLength) return null;
            return JSON.parse(serialized);
        } catch (_error) {
            return null;
        }
    }

    private normalizeFloatingResultReferences(value: any) {
        if (!Array.isArray(value)) return [];
        return value.slice(0, 20).filter((item: any) => item && typeof item === 'object');
    }

    private applyFloatingServerConversationEnvelope(payload: any) {
        const binding = this.normalizeFloatingConversationBinding(
            payload?.conversationBinding || payload?.analysis?.conversationBinding
        );
        if (binding) this.floatingConversationBinding = binding;
        const state = this.cloneFloatingServerEnvelopeValue(
            payload?.conversationState || payload?.analysis?.conversationState,
            128 * 1024
        );
        if (state && typeof state === 'object' && !Array.isArray(state)) {
            this.floatingConversationState = state;
        }
        const executionRequest = this.cloneFloatingServerEnvelopeValue(
            payload?.executionRequest || payload?.analysis?.executionRequest
        );
        if (executionRequest && typeof executionRequest === 'object' && !Array.isArray(executionRequest)) {
            this.floatingExecutionRequest = executionRequest;
        }
        const references = Array.isArray(payload?.resultReferences)
            ? payload.resultReferences
            : state?.resultReferences;
        if (Array.isArray(references)) this.floatingResultReferences = this.normalizeFloatingResultReferences(references);
        return binding;
    }

    public showFloatingIntentReview(message: any) {
        return Boolean(
            message?.role === 'assistant'
            && message?.intentReview
            && ['awaiting', 'editing', 'analyzing'].includes(message.intentReview.status)
        );
    }

    public hasPendingFloatingIntentReview() {
        return (this.floatingChatMessages || []).some((message: any) =>
            message?.intentReview && ['awaiting', 'editing', 'analyzing'].includes(message.intentReview.status)
        );
    }

    public floatingIntentReviewStatusLabel(message: any) {
        const labels: any = {
            awaiting: '사용자 확인 대기',
            editing: '수정 입력 중',
            analyzing: '재분석 중',
            confirmed: '확인 완료'
        };
        return labels[message?.intentReview?.status] || '검토 중';
    }

    public floatingAgentModeButtonClass(mode: string) {
        return this.floatingAgentMode === mode ? 'is-active' : '';
    }

    public floatingIntentCorrectionModeClass(message: any, mode: string) {
        return message?.intentReview?.correctionAgentMode === mode ? 'is-active' : '';
    }

    public selectFloatingAgentMode(mode: string) {
        if (this.locked) return;
        if (this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        if (!this.floatingAgentModes.some((item: any) => item.id === mode)) return;
        this.floatingAgentMode = mode;
        void this.service.render();
    }

    public async selectFloatingToolMode(mode: string) {
        if (this.locked || this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        if (!this.floatingToolExecutionModes.some(item => item.id === mode)) return;
        this.floatingToolExecutionMode = mode;
        await this.service.render();
    }

    public async selectTrainingFile(event: Event) {
        if (this.locked || this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        await this.alsphereChat.selectFile(event);
    }

    public async clearTrainingFile() {
        if (this.locked || this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        await this.alsphereChat.clearFile();
    }

    public async checkAlsphereStatus() {
        if (this.locked || this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        await this.alsphereChat.checkStatus();
    }

    public async cancelAlsphereConversation() {
        if (this.locked || this.floatingChatAsking || this.hasPendingFloatingIntentReview()) return;
        await this.alsphereChat.cancel();
    }

    public floatingAgentModeTitle(mode: string) {
        const category = ['virtual_metrology', 'anomaly'].includes(mode) ? 'ai_model' : mode;
        const found = this.floatingAgentModes.find((item: any) => item.id === category);
        return found?.title || found?.label || mode || '자동 선택';
    }

    public floatingIntentLabel(intent: string) {
        const labels: any = {
            general: '일반 질문',
            explain: '개념 설명',
            search: '데이터 검색',
            predict: '가상 계측',
            anomaly: '이상 탐지',
            optimize: '조건 최적화',
            compare: 'Trace 비교',
            spc: 'SPC 분석',
            research: '문서 조사',
            report: '보고서 생성'
        };
        return labels[String(intent || '').toLowerCase()] || intent || '질문 분석';
    }

    public floatingToolExecutionModeLabel(mode: string) {
        const labels: any = {
            auto: '자동 실행',
            sequential: '순차 실행',
            parallel: '병렬 실행'
        };
        return labels[String(mode || '').toLowerCase()] || mode || '자동 실행';
    }

    public floatingSkillLabel(skill: string) {
        const labels: any = {
            'rag.search': '문서 검색',
            'process.search': '공정 검색',
            'data.search': 'BANDI 공정 데이터 검색',
            'dataset.search': 'BANDI 데이터셋 검색',
            'model.predict': 'AI 모델 예측',
            'analytics.analyze': 'RCA 분석',
            'trace.compare': 'Trace 비교',
            'optimize.recommend': '조건 추천',
            'report.compose': '보고서 초안',
            'chart.render': '시각화'
        };
        return labels[String(skill || '')] || skill;
    }

    public floatingToolExecutionSummary(message: any) {
        const review = message?.intentReview || message || {};
        const waves = this.floatingExecutionWaves(review);
        const skills = Array.isArray(review.skills)
            ? review.skills
            : Array.isArray(review.tools) ? review.tools : [];
        const parallel = waves.filter((wave: any) => (wave.tools || []).length > 1).length;
        const totalTools = skills.length || waves.reduce((sum: number, wave: any) => sum + (wave.tools || []).length, 0);
        const parts = [
            `${waves.length || 1}개 Wave`,
            parallel ? `${parallel}개 병렬 Wave` : '',
            `${totalTools}개 Tool`
        ].filter(Boolean);
        return parts.join(' · ');
    }

    public floatingExecutionWaves(source: any) {
        const waves = source?.executionWaves || source?.toolExecutionPlan?.waves || source?.executionWaveResults || [];
        if (!Array.isArray(waves)) return [];
        return waves.slice(0, 6).map((wave: any, index: number) => {
            const tools = Array.isArray(wave?.tools)
                ? wave.tools
                : Array.isArray(wave?.submittedTools) ? wave.submittedTools : Array.isArray(wave) ? wave : [];
            return {
                index: Number(wave?.index || index + 1),
                status: wave?.status || 'planned',
                elapsedMs: wave?.elapsedMs,
                tools: tools.map((tool: any) => String(tool?.name || tool || '')).filter(Boolean).slice(0, 5)
            };
        });
    }

    public floatingResponseComplete(message: any) {
        return Boolean(message?.role === 'assistant' && !message?.processing && !this.showFloatingIntentReview(message));
    }

    public floatingArtifactAllowed(message: any, key: string) {
        const policy = message?.artifactPolicy;
        if (policy && typeof policy[key] === 'boolean') return policy[key];
        return !['general', 'explain', 'site'].includes(String(message?.intent || '').toLowerCase());
    }

    public showFloatingTable(message: any) {
        return !this.service.chatPresentation.hasAnswerTable(message)
            && this.floatingResponseComplete(message)
            && this.floatingArtifactAllowed(message, 'execution')
            && String(message?.dataScope || '').toLowerCase() !== 'no_data'
            && !['failed', 'error', 'blocked', 'no_data'].includes(String(message?.status || '').toLowerCase())
            && Boolean(message?.table?.columns?.length && message?.table?.rows?.length);
    }

    public floatingTableColumns(message: any) {
        const columns = Array.isArray(message?.table?.columns) ? message.table.columns : [];
        return columns.slice(0, 6).map((column: any, index: number) => {
            if (typeof column === 'string') {
                return { key: column, label: column, index };
            }
            const key = String(column?.key || column?.field || column?.name || column?.label || index);
            return {
                key,
                label: String(column?.label || column?.name || column?.title || key),
                index
            };
        });
    }

    public floatingTableRows(message: any) {
        const rows = Array.isArray(message?.table?.rows) ? message.table.rows : [];
        return rows.slice(0, 10);
    }

    public floatingTableCell(row: any, column: any) {
        if (!row || !column) return '-';
        const value = Array.isArray(row)
            ? row[Number(column.index || 0)]
            : row[column.key];
        if (value === undefined || value === null || value === '') return '-';
        if (typeof value === 'number') {
            return value.toLocaleString('ko-KR', { maximumSignificantDigits: 10 });
        }
        return String(value);
    }

    public showFloatingChart(message: any) {
        return this.floatingResponseComplete(message)
            && this.floatingArtifactAllowed(message, 'chart')
            && !['no_data', 'failed', 'error'].includes(String(message?.dataScope || '').toLowerCase())
            && !['failed', 'error', 'blocked', 'no_data'].includes(String(message?.status || '').toLowerCase())
            && !['failed', 'error', 'blocked', 'no_data'].includes(String(message?.chart?.status || '').toLowerCase())
            && this.floatingChartPoints(message).length > 0;
    }

    public floatingChartPoints(message: any) {
        const points = Array.isArray(message?.chart?.points) ? message.chart.points : [];
        return points.map((point: any, index: number) => ({
            label: String(point?.label ?? point?.name ?? point?.x ?? message?.chart?.labels?.[index] ?? `P${index + 1}`),
            value: this.floatingChartPointValue(point),
            unit: String(point?.unit || message?.chart?.unit || '')
        })).filter((point: any) => Number.isFinite(point.value)).slice(0, 10);
    }

    public floatingChartPointValue(point: any) {
        if (point && typeof point === 'object') {
            const candidates = [point.value, point.y, point.metric, point.score, point.predicted];
            for (const candidate of candidates) {
                if (candidate == null || typeof candidate === 'boolean' || typeof candidate === 'object' || String(candidate).trim() === '') continue;
                const value = Number(candidate);
                if (Number.isFinite(value)) return value;
            }
            return NaN;
        }
        if (point == null || typeof point === 'boolean' || String(point).trim() === '') return NaN;
        const value = Number(point);
        return Number.isFinite(value) ? value : NaN;
    }

    public showFloatingAnswerQuality(message: any) {
        return this.floatingResponseComplete(message) && Boolean(message?.question || message?.intent || message?.answerQuality);
    }

    public floatingAnswerQualityLabel(message: any) {
        if (message?.answerQuality?.label) return message.answerQuality.label;
        if (String(message?.dataScope || '').toLowerCase() === 'no_data') return '판단 보류';
        if (this.floatingEvidenceCount(message)) return '근거 검증 확인';
        if (!message?.actions?.length && ['general', 'site', 'explain'].includes(String(message?.intent || ''))) return '안내 응답';
        return '근거 확인 필요';
    }

    public floatingAnswerQualitySummary(message: any) {
        if (message?.answerQuality?.summary) return message.answerQuality.summary;
        const evidence = this.floatingEvidenceCount(message);
        if (evidence) return `응답에 참고 근거 ${evidence}건과 실행 결과를 연결했습니다.`;
        if (String(message?.dataScope || '').toLowerCase() === 'no_data') return '일치하는 데이터 근거가 없어 예측이나 원인 판단을 보류했습니다.';
        return '플로팅 챗봇에서도 AI 화면과 같은 Agent 실행 결과를 요약 표시합니다.';
    }

    public floatingEvidenceCount(message: any) {
        return (message?.evidence || []).length
            + (message?.citations || []).length
            + this.normalizeFloatingResultReferences(message?.resultReferences).length;
    }

    public floatingSourceItems(message: any) {
        if (this.service.chatPresentation.isDataSearch(message)) return [];
        const evidence = Array.isArray(message?.evidence) ? message.evidence.slice(0, 100) : [];
        const citations = Array.isArray(message?.citations) ? message.citations.slice(0, 100) : [];
        return [
            ...evidence.map((item: any, index: number) => ({
                id: String(item?.id || `evidence-${index + 1}`),
                documentSource: this.service.chatPresentation.isDocumentSource(item),
                usage: item?.usage || 'reference', typeLabel: item?.typeLabel, title: item?.title,
                label: String(item?.title || item?.document || item?.id || '검증 근거')
                    + (this.service.chatPresentation.evidencePage(item) ? ` · p.${this.service.chatPresentation.evidencePage(item)}` : ''),
                detailApi: item?.detailApi === 'knowledge_document_evidence' ? item.detailApi : '',
                documentId: String(item?.documentId || ''),
                chunkId: String(item?.chunkId || ''),
                page: this.service.chatPresentation.evidencePage(item),
                detail: [item?.source, item?.subtitle, item?.typeLabel]
                    .map((value: any) => String(value || '').trim())
                    .filter(Boolean)
                    .filter((value: string, valueIndex: number, values: string[]) => values.indexOf(value) === valueIndex)
                    .join(' · '),
                excerpt: String(item?.excerpt || item?.summary || '').trim(),
                supports: String(item?.supports || '').trim(),
                fields: Object.entries(item?.fields || {})
                    .filter(([key, value]) => !/service.?key|api.?key|token|password|secret|authorization/i.test(key)
                        && value != null && typeof value !== 'object' && String(value).trim() !== '')
                    .slice(0, 20).map(([key, value]) => ({ key, value: String(value) }))
            })),
            ...citations.map((citation: any, index: number) => ({
                id: `citation-${index + 1}`, documentSource: true, usage: 'reference',
                ...this.service.chatPresentation.citationSource(citation, evidence),
                detail: String(citation || ''), excerpt: '', supports: '', fields: []
            })).filter((item: any) => item.label && !evidence.some((source: any) => item.detail === String(source?.id || '')
                || item.detail === String(source?.title || '')))
        ].filter((item: any, index: number, items: any[]) => items.findIndex(source => source.id === item.id) === index);
    }

    public floatingSourceTrack(_index: number, source: any) {
        return source.id;
    }

    public floatingSourceDetail(message: any, source: any) {
        return message?.sourceDetails?.[source.id] || source;
    }

    public async zoomFloatingSourceImage(message: any, source: any, change: number) {
        this.service.chatPresentation.zoomEvidenceImage(this.floatingSourceDetail(message, source)?.pageImage, change);
        await this.service.render();
    }

    private guestChatForm() {
        const form = new FormData();
        const token = this.service.auth?.status === true ? '' : this.service.auth?.session?.guest_csrf;
        if (token) form.set('chat_csrf_token', String(token));
        return form;
    }

    private async fetchFloatingSource(api: string, params: any, signal: AbortSignal) {
        const form = this.guestChatForm();
        for (const [key, value] of Object.entries(params)) form.append(key, String(value));
        const response = await fetch(`/wiz/api/page.agent/${api}`, {
            method: 'POST', body: form, credentials: 'same-origin', signal
        });
        const envelope = await this.readFloatingJson(response, '문서 내용을 해석하지 못했습니다.');
        if (!response.ok || Number(envelope?.code) !== 200) throw new Error(envelope?.data?.message || envelope?.data?.error?.message || '원본 PDF 페이지를 불러오지 못했습니다. 접근 권한을 확인해 주세요.');
        return this.floatingPayload(envelope.data);
    }

    public async toggleFloatingSource(message: any, source: any, event: Event) {
        const expanded = Boolean((event.target as HTMLDetailsElement)?.open);
        if (!message.sourceDetails) message.sourceDetails = Object.create(null);
        const previous = message.sourceDetails[source.id];
        if (previous?.controller) previous.controller.abort();
        const detail = { ...source, open: expanded, loading: false, error: '', pageImage: null, controller: null as AbortController | null };
        message.sourceDetails[source.id] = detail;
        if (!expanded || source.detailApi !== 'knowledge_document_evidence' || !source.documentId) {
            await this.service.render();
            return;
        }
        const controller = new AbortController();
        detail.controller = controller;
        detail.loading = true;
        this.floatingSourceRequests.add(controller);
        const timeout = setTimeout(() => controller.abort(), 30000);
        await this.service.render();
        try {
            const params = this.service.chatPresentation.evidencePreviewParams(source);
            const preview = await this.fetchFloatingSource('knowledge_document_evidence_preview', params, controller.signal);
            if (controller.signal.aborted || message.sourceDetails[source.id] !== detail) return;
            detail.pageImage = this.service.chatPresentation.evidenceImage(preview, source);
        } catch (error: any) {
            if (message.sourceDetails[source.id] !== detail || !detail.open) return;
            detail.error = error?.message || '원본 PDF 페이지를 불러오지 못했습니다. 문서 형식과 접근 권한을 확인해 주세요.';
        } finally {
            clearTimeout(timeout);
            this.floatingSourceRequests.delete(controller);
            detail.controller = null;
            detail.loading = false;
            if (!this.floatingDestroyed && this.floatingChatMessages.includes(message)) await this.service.render();
        }
    }

    private cancelFloatingSourceRequests() {
        for (const controller of this.floatingSourceRequests) controller.abort();
        this.floatingSourceRequests.clear();
    }

    public floatingChartHeight(value: any, points: any[]) {
        const values = (points || [])
            .map((item: any) => this.floatingChartPointValue(item))
            .filter((item: number) => Number.isFinite(item));
        const numeric = this.floatingChartPointValue(value);
        if (!Number.isFinite(numeric) || !values.length) return '0%';
        const range = Math.max(0, ...values) - Math.min(0, ...values);
        return range ? `${Math.abs(numeric) / range * 100}%` : '0%';
    }

    public floatingChartBottom(value: any, points: any[]) {
        const values = (points || []).map((item: any) => this.floatingChartPointValue(item)).filter(Number.isFinite);
        const minimum = Math.min(0, ...values);
        const range = Math.max(0, ...values) - minimum;
        const numeric = this.floatingChartPointValue(value);
        return range && Number.isFinite(numeric) ? `${(Math.min(0, numeric) - minimum) / range * 100}%` : '0%';
    }

    public floatingChartCaption(message: any) {
        const chart = message?.chart || {};
        const coverage = chart.coverage || {};
        const notes = [String(chart.caption || '').trim()];
        const shown = this.floatingChartPoints(message).length;
        if (coverage.returnedRows != null) notes.push(`조회 ${coverage.returnedRows}행 중 ${shown}개 값 표시`);
        else if (chart.points?.length > shown) notes.push(`유효한 값 중 ${shown}개 표시`);
        if (coverage.providerTotal != null) notes.push(`전체 ${coverage.providerTotal}행`);
        return notes.filter(Boolean).join(' · ');
    }

    public floatingChartValueLabel(value: any, unit: string = '') {
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return '-';
        return `${numeric.toLocaleString('ko-KR', { maximumSignificantDigits: 6 })}${unit ? ` ${unit}` : ''}`;
    }

    public floatingFallbackArtifactPolicy(meta: any) {
        const intent = String(meta?.intent || '').toLowerCase();
        const dataRelated = ['search', 'anomaly', 'optimize', 'research', 'report', 'predict', 'compare', 'spc'].includes(intent);
        return {
            progress: dataRelated && Boolean((meta?.stages || []).length),
            execution: dataRelated && Boolean((meta?.actions || []).length || meta?.table || meta?.markdown),
            chart: dataRelated && Boolean(meta?.chart)
        };
    }

    public isFloatingReport(message: any) {
        return this.floatingResponseComplete(message)
            && message?.intent === 'report'
            && (Boolean(String(message?.markdown || '').trim()) || message?.intent === 'report');
    }

    public floatingReportPreview(message: any) {
        const markdown = String(message?.markdown || '').trim();
        if (!markdown) return '보고서 초안을 생성하지 못했습니다. 상세 작성 화면에서 다시 요청해 주세요.';
        return markdown.length > 1200 ? `${markdown.slice(0, 1200).trimEnd()}\n…` : markdown;
    }

    public downloadFloatingReport(message: any) {
        const markdown = String(message?.markdown || '').trim();
        if (!markdown || typeof document === 'undefined' || typeof URL === 'undefined') return;
        const heading = markdown.split('\n').find((line: string) => /^#\s+/.test(line)) || 'NanoFab AI 보고서';
        const filename = heading.replace(/^#\s+/, '').replace(/[\\/:*?"<>|]+/g, '-').trim().slice(0, 80) || 'nanofab-ai-report';
        const url = URL.createObjectURL(new Blob([markdown], { type: 'text/markdown;charset=utf-8' }));
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `${filename}.md`;
        document.body.appendChild(anchor);
        anchor.click();
        anchor.remove();
        const releaseUrl = () => URL.revokeObjectURL(url);
        this.scheduleFloatingTimer(releaseUrl, 0, releaseUrl);
    }

    private floatingConversationContext() {
        const rows: any[] = [];
        let remaining = 6000;
        const messages = this.floatingChatMessages.slice(-8).reverse();
        for (const message of messages) {
            if (message?.role !== 'user' && message?.role !== 'assistant') continue;
            if (message?.processing || this.showFloatingIntentReview(message)) continue;
            const content = String(message?.content || '').replace(/\s+/g, ' ').trim().slice(0, 1200);
            if (!content || remaining <= 0) continue;
            rows.unshift({ role: message.role, content: content.slice(0, remaining) });
            remaining -= Math.min(content.length, remaining);
        }
        return this.floatingContextWithConversationBinding(
            { messages: rows },
            this.floatingConversationBinding
        );
    }

    private trimFloatingChatMessages() {
        // Preserve the complete transcript; only model request context is bounded.
    }

    private scrollFloatingChatToLatestMessage() {
        this.scheduleFloatingTimer(() => {
            const body = this.element.nativeElement.querySelector('.nf-floating-chat-body') as HTMLElement | null;
            if (!body) return;
            // Check the current state inside the timer: a queued progress scroll
            // must not move a newly completed answer back to its bottom.
            const latest = this.floatingChatMessages[this.floatingChatMessages.length - 1];
            if (latest?.question && latest?.content && this.floatingResponseComplete(latest)) {
                const messages = body.querySelectorAll<HTMLElement>('.nf-floating-chat-message[data-chat-role]');
                this.service.chatPresentation.scrollToAnswerStart(body, messages[messages.length - 1]);
            } else {
                body.scrollTop = body.scrollHeight;
            }
        }, 0);
    }

}

export default PortalFabChatComponent;